"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3231],{

/***/ 44395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}





const Border = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    background-color: ".concat(theme.palette.background.disabled, ";\n    height: 2px;\n    position: relative;\n  ");
});
const SelectedBar = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1(), (param)=>{
    let { theme , $start  } = param;
    return "\n    background-color: ".concat(theme.palette.text.minus2, ";\n    height: 2px;\n    left: 0;\n    width: ").concat($start ? "100%" : "0", ";\n    position: absolute;\n    transition: width 5s ease-out;\n  ");
});
const SelectedAnimation = ()=>{
    const [start, setStart] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setTimeout(()=>setStart(true));
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SelectedBar, {
        $start: start
    });
};
const DesktopPaginationWithTitle = (param)=>{
    let { data , currentIndex , onPaginationIndexClick  } = param;
    var _data_map;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        display: "flex",
        justifyContent: "center",
        mt: {
            md: 10
        },
        children: data === null || data === void 0 ? void 0 : (_data_map = data.map) === null || _data_map === void 0 ? void 0 : _data_map.call(data, (banner, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                onClick: ()=>onPaginationIndexClick(index),
                sx: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    width: "152px",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Border, {
                            children: currentIndex === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SelectedAnimation, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "body1",
                            color: currentIndex === index ? "text.minus2" : "background.disabled",
                            fontWeight: "fontWeightBold",
                            py: 4,
                            px: 3,
                            textAlign: "center",
                            children: banner.title || banner.name
                        })
                    ]
                })
            }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DesktopPaginationWithTitle);


/***/ }),

/***/ 79450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67074);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75084);
// 開發進度: 已完成 contained 樣式的 large、medium、small 三種尺寸的按鈕，並設定了三種顏色的主題，分別為 primary、warning、neutral



const StyledButton = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((param)=>{
    let { theme , size , color , variant , fullWidth  } = param;
    return {
        width: fullWidth ? "100%" : "fit-content",
        borderRadius: "4px",
        textTransform: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: theme.typography.fontWeightRegular,
        // Large button styles
        ...size === "large" && {
            padding: variant === "outlined" ? "15px 19px" : "16px 20px",
            minHeight: "56px",
            fontSize: theme.typography.bodyLarge.fontSize,
            "& .MuiButton-startIcon, & .MuiButton-endIcon": {
                "& > *:first-of-type": {
                    fontSize: "24px"
                }
            },
            "& .MuiButton-startIcon": {
                marginRight: "8px",
                marginLeft: 0
            },
            "& .MuiButton-endIcon": {
                marginRight: 0,
                marginLeft: "8px"
            }
        },
        // Medium button styles
        ...size === "medium" && {
            padding: variant === "outlined" ? "11px 15px" : "12px 16px",
            minHeight: "44px",
            fontSize: theme.typography.bodyMedium.fontSize,
            "& .MuiButton-startIcon, & .MuiButton-endIcon": {
                "& > *:first-of-type": {
                    fontSize: "20px"
                }
            },
            "& .MuiButton-startIcon": {
                marginRight: "6px",
                marginLeft: 0
            },
            "& .MuiButton-endIcon": {
                marginRight: 0,
                marginLeft: "6px"
            }
        },
        // Small button styles
        ...size === "small" && {
            padding: variant === "outlined" ? "9px 11px" : "10px 12px",
            minHeight: "37px",
            fontSize: theme.typography.bodySmall.fontSize,
            "& .MuiButton-startIcon, & .MuiButton-endIcon": {
                "& > *:first-of-type": {
                    fontSize: "16px"
                }
            },
            "& .MuiButton-startIcon": {
                marginRight: "4px",
                marginLeft: 0
            },
            "& .MuiButton-endIcon": {
                marginRight: 0,
                marginLeft: "4px"
            }
        },
        // 狀態設定
        "&.Mui-disabled": {
            backgroundColor: theme.palette.background.disabled,
            color: theme.palette.text.disabled
        },
        // 顏色&風格設定
        ...color === "warning" && variant === "contained" && {
            backgroundColor: theme.palette.error.main,
            "&:hover": {
                backgroundColor: theme.palette.error.light
            },
            "&:active": {
                backgroundColor: theme.palette.error.dark
            }
        },
        ...color === "primary" && variant === "contained" && {
            "&:hover": {
                backgroundColor: theme.palette.green.secondary
            },
            "&:active": {
                backgroundColor: theme.palette.primary.mainPlus2
            }
        },
        ...color === "neutral" && variant === "contained" && {
            color: theme.palette.white.main,
            backgroundColor: theme.palette.neutral.main,
            "&:hover": {
                backgroundColor: theme.palette.neutral.light
            },
            "&:active": {
                backgroundColor: theme.palette.neutral.dark
            }
        }
    };
});
const ButtonBasic = (param)=>{
    let { children , size ="large" , startIcon , endIcon , variant ="contained" , color ="primary" , disabled =false , fullWidth =false , onClick , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
        size: size,
        startIcon: startIcon,
        endIcon: endIcon,
        variant: variant,
        color: color,
        disabled: disabled,
        fullWidth: fullWidth,
        onClick: onClick,
        ...props,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonBasic);


/***/ }),

/***/ 47216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  p {\n    margin: 0;\n  }\n\n  .ql-align-center {\n    text-align: center;\n  }\n  .ql-align-right {\n    text-align: right;\n  }\n  .ql-align-justify {\n    text-align: justify;\n  }\n\n  img {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  p {\n    font-size: 18px;\n    letter-spacing: 0.02rem;\n    line-height: 2rem;\n  }\n\n  img {\n    margin: 18px 0;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Content = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject());
const ArticleContent = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Content)(_templateObject1());
const HTMLContent = (param)=>{
    let { content , type  } = param;
    if (!content) {
        return null;
    }
    return type === "article" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArticleContent, {
        dangerouslySetInnerHTML: {
            __html: content
        }
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Content, {
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HTMLContent);


/***/ }),

/***/ 26643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_hooks_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53258);
/* harmony import */ var use_deep_compare_effect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87620);
/* harmony import */ var utils_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13946);
/* harmony import */ var components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98780);
/*
 * 配合react-infinite-scroll-component使用
 * 當需要scrollableTarget時(在element scroll而不是window)
 * 須給定element實際的height pixel
 */ 
function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  overflow-y: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: ",
        "px;\n  overflow-y: auto;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}








const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject());
const HeightSyncToContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1(), (props)=>props.height);
const InfiniteContainer = (param)=>{
    let { children , id , containerRef , filterState ={} , ...rest } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { page  } = (router === null || router === void 0 ? void 0 : router.query) || {};
    const [node, nodeRef] = (0,utils_hooks_dom__WEBPACK_IMPORTED_MODULE_5__/* .useStateRef */ .Y)();
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const scrollableRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const { showButton , showScrollButton  } = (0,utils_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useShowScrollToTopButton */ .zi)();
    // 判斷當有頁面 query 且改變時為點擊換頁，使頁面置頂
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((router === null || router === void 0 ? void 0 : router.pathname) === "/vender" && page) {
            setTimeout(()=>{
                var _scrollableRef_current;
                return (scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) && (scrollableRef === null || scrollableRef === void 0 ? void 0 : (_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                    top: 0,
                    behavior: "smooth"
                }));
            }, 0);
        }
    }, [
        page,
        filterState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) && containerRef) {
            containerRef.current = scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current;
        }
    }, [
        scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current,
        containerRef
    ]);
    const handleResize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        if (node) {
            setHeight(node.clientHeight);
        }
    }, [
        node
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!node) {
            return;
        }
        const observer = new ResizeObserver(handleResize);
        observer.observe(node);
        return ()=>{
            observer.unobserve(node);
        };
    }, [
        node,
        handleResize
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        ref: nodeRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HeightSyncToContainer, {
            height: height,
            id: id,
            ref: scrollableRef,
            onScroll: showScrollButton,
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    showButton: showButton,
                    scrollableRef: scrollableRef
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfiniteContainer);


/***/ }),

/***/ 7739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16423);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const InfoBlock = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $error , $radius , $orderHint , $bgColor , $borderColor  } = param;
    return "\n    background-color: ".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([
        [
            (conditions)=>conditions.$error,
            ()=>theme.palette.secondary.bg
        ],
        [
            (props)=>!!props.$bgColor,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(theme.palette, $bgColor)
        ],
        [
            ()=>true,
            ()=>theme.palette.primary.bgPlus1
        ]
    ])({
        $error,
        $bgColor
    }), ";\n    border-radius: ").concat($radius !== null && $radius !== void 0 ? $radius : 4, "px;\n    border: ").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([
        [
            (props)=>props.$error,
            ()=>"1px solid #FFCAB9"
        ],
        [
            (props)=>props.$orderHint,
            ()=>"1px solid #C3DB92"
        ],
        [
            (props)=>!!props.$borderColor,
            ()=>"1px solid ".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(theme.palette, $borderColor))
        ]
    ])({
        $error,
        $orderHint,
        $borderColor
    }), ";\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (InfoBlock);


/***/ }),

/***/ 70779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29630);
/* harmony import */ var components_common_ButtonBasic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79450);
/* harmony import */ var components_common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37524);





const LoginRequiredModal = (param)=>/*#__PURE__*/ {
    let { open , onClose , onLogin  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_common_Modal__WEBPACK_IMPORTED_MODULE_2__/* .InfoModal */ .nv, {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "titleLarge",
                p: 5,
                children: "請先登入會員方可查看內容及使用會員服務"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "flex-end",
                gap: 2.5,
                p: 5,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ButtonBasic__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        variant: "outlined",
                        onClick: onClose,
                        size: "medium",
                        color: "neutral",
                        children: "取消"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ButtonBasic__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        variant: "contained",
                        onClick: onLogin,
                        size: "medium",
                        id: "login",
                        children: "登入"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginRequiredModal);


/***/ }),

/***/ 2925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  ",
        ";\n  line-height: ",
        ";\n  height: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const NowrapDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { $lines  } = param;
    return !!$lines && $lines > 1 ? "display: -webkit-box;" + "-webkit-line-clamp: ".concat($lines, ";") + "-webkit-box-orient: vertical;" : "white-space: nowrap;";
}, (param)=>{
    let { $fixHeight  } = param;
    return $fixHeight ? "1.2em" : "";
}, (param)=>{
    let { $lines , $fixHeight  } = param;
    return $fixHeight ? ($lines || 1) * 1.2 + "em" : "auto";
}, (param)=>{
    let { $textCenter  } = param;
    return $textCenter ? "center" : "left";
});
/* harmony default export */ __webpack_exports__["Z"] = (NowrapDiv);


/***/ }),

/***/ 99469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1216);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61953);




const moduleMap = {
    graphicFix: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(5616), __webpack_require__.e(5795), __webpack_require__.e(1427)]).then(__webpack_require__.bind(__webpack_require__, 45941)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(45941)
                    ]
            },
            ssr: false
        }),
        minHeight: 250
    },
    graphicMore: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5616), __webpack_require__.e(6760), __webpack_require__.e(4700)]).then(__webpack_require__.bind(__webpack_require__, 25975)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(25975)
                    ]
            },
            ssr: false
        }),
        minHeight: 250
    },
    publicitySmall: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5616), __webpack_require__.e(8757)]).then(__webpack_require__.bind(__webpack_require__, 8757)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(8757)
                    ]
            },
            ssr: false
        }),
        minHeight: 385
    },
    publicityLarge: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5616), __webpack_require__.e(8902)]).then(__webpack_require__.bind(__webpack_require__, 88902)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(88902)
                    ]
            },
            ssr: false
        }),
        minHeight: 500
    },
    banner: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(6760), __webpack_require__.e(8121), __webpack_require__.e(9260)]).then(__webpack_require__.bind(__webpack_require__, 24200)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(24200)
                    ]
            },
            ssr: false
        }),
        minHeight: 190
    },
    bannerLarge: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 1040).then(__webpack_require__.bind(__webpack_require__, 61040)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(61040)
                    ]
            },
            ssr: false
        }),
        minHeight: 100
    },
    articleMainImage: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(5616), __webpack_require__.e(5795), __webpack_require__.e(4891)]).then(__webpack_require__.bind(__webpack_require__, 28303)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(28303)
                    ]
            },
            ssr: false
        }),
        minHeight: 400
    },
    articleSmallImage: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(5616), __webpack_require__.e(5795), __webpack_require__.e(5084)]).then(__webpack_require__.bind(__webpack_require__, 92952)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(92952)
                    ]
            },
            ssr: false
        }),
        minHeight: 170
    },
    customHtml: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 643).then(__webpack_require__.bind(__webpack_require__, 20643)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(20643)
                    ]
            },
            ssr: true
        }),
        minHeight: 1
    },
    graphicN: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5795), __webpack_require__.e(2175)]).then(__webpack_require__.bind(__webpack_require__, 59997)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(59997)
                    ]
            },
            ssr: false
        }),
        minHeight: 250
    }
};
const Present = (param)=>{
    let { data , lazy , lazyOptions , isServicePage =false  } = param;
    if (!moduleMap[data === null || data === void 0 ? void 0 : data.type]) {
        return null;
    }
    const { component: DynamicModule , minHeight  } = moduleMap[data === null || data === void 0 ? void 0 : data.type];
    const minHeightValue = typeof minHeight === "function" ? minHeight(data) : minHeight;
    if (lazy) {
        var _lazyOptions_offset;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            height: minHeightValue,
            offset: (_lazyOptions_offset = lazyOptions === null || lazyOptions === void 0 ? void 0 : lazyOptions.offset) !== null && _lazyOptions_offset !== void 0 ? _lazyOptions_offset : 0,
            scrollContainer: (lazyOptions === null || lazyOptions === void 0 ? void 0 : lazyOptions.containerId) && "#".concat(lazyOptions.containerId),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                minHeight: minHeightValue,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicModule, {
                    data: data,
                    isServicePage: isServicePage
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        minHeight: minHeightValue,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicModule, {
            data: data,
            isServicePage: isServicePage
        })
    });
};
Present.defaultProps = {
    lazy: false,
    lazyOptions: {
        offset: 0,
        containerId: ""
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (Present);


/***/ }),

/***/ 54996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98700);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const ResponsiveDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), _mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveDiv);


/***/ }),

/***/ 67749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ AlertCircleSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const AlertCircleSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            className: "ic_alert_circle",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z",
                    className: "Vector (Stroke)",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M11 16a1 1 0 011-1h.01a1 1 0 110 2H12a1 1 0 01-1-1z",
                    className: "Vector (Stroke)_2",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M12 7a1 1 0 011 1v4a1 1 0 11-2 0V8a1 1 0 011-1z",
                    className: "Vector (Stroke)_3",
                    clipRule: "evenodd"
                })
            ]
        })
    });
};


/***/ }),

/***/ 23183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ EyeSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const EyeSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            className: "btn_eye_off",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M2.14 12a18.68 18.68 0 002.464 3.316C6.397 17.226 8.9 19 12 19c3.1 0 5.605-1.774 7.395-3.684A18.684 18.684 0 0021.86 12a18.681 18.681 0 00-2.464-3.316C17.605 6.774 15.101 5 12 5 8.9 5 6.396 6.774 4.605 8.684A18.678 18.678 0 002.14 12zM23 12l.894-.448-.002-.003-.003-.007-.011-.022a10.615 10.615 0 00-.192-.354 20.675 20.675 0 00-2.831-3.85C18.895 5.226 15.899 3 12 3 8.1 3 5.104 5.226 3.145 7.316a20.674 20.674 0 00-2.831 3.85 12.375 12.375 0 00-.192.354l-.011.022-.003.007-.002.002s0 .002.894.449l-.894-.447a1 1 0 000 .894L1 12l-.894.447.002.004.003.007.011.022a8.267 8.267 0 00.192.354 20.67 20.67 0 002.831 3.85C5.105 18.774 8.1 21 12 21c3.9 0 6.895-2.226 8.855-4.316a20.672 20.672 0 002.831-3.85 11.81 11.81 0 00.192-.354l.011-.022.003-.007.002-.002s0-.002-.894-.449zm0 0l.894.447c.141-.281.14-.613 0-.895L23 12z",
                    className: "Vector (Stroke)",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M12 10a2 2 0 100 4 2 2 0 000-4zm-4 2a4 4 0 118 0 4 4 0 01-8 0z",
                    className: "Vector (Stroke)_2",
                    clipRule: "evenodd"
                })
            ]
        })
    });
};


/***/ }),

/***/ 78098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useCustomSticky; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var config_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26059);
/* harmony import */ var utils_hooks_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53258);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




const useCustomSticky = ()=>{
    const [gridNode, gridRef] = (0,utils_hooks_dom__WEBPACK_IMPORTED_MODULE_4__/* .useStateRef */ .Y)();
    const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // customTabsRef 目前應該還不會用到
    const customTabsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [isSticky, setIsSticky] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const handleScroll = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((gridRect, containerRect, customTabsRect)=>{
        if (gridRect.top <= containerRect.top) {
            !isSticky && setIsSticky(true);
            !isSticky && console.log("set to sticky") // debug
            ;
        } else {
            isSticky && setIsSticky(false);
            isSticky && console.log("set to not sticky") // debug
            ;
        }
    }, [
        isSticky
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var _containerRef_current, _customTabsRef_current;
        const onContainerScroll = ()=>{
            if (gridNode) {
                var _containerRef_current, _customTabsRef_current;
                handleScroll(gridNode.getBoundingClientRect(), (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.getBoundingClientRect(), (_customTabsRef_current = customTabsRef.current) === null || _customTabsRef_current === void 0 ? void 0 : _customTabsRef_current.getBoundingClientRect());
            }
        };
        (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.addEventListener("scroll", onContainerScroll);
        (_customTabsRef_current = customTabsRef.current) === null || _customTabsRef_current === void 0 ? void 0 : _customTabsRef_current.addEventListener("scroll", onContainerScroll);
        return ()=>{
            var _containerRef_current, _customTabsRef_current;
            (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.removeEventListener("scroll", onContainerScroll);
            (_customTabsRef_current = customTabsRef.current) === null || _customTabsRef_current === void 0 ? void 0 : _customTabsRef_current.removeEventListener("scroll", onContainerScroll);
        };
    }, [
        handleScroll,
        gridNode,
        containerRef.current,
        customTabsRef.current
    ]);
    const [gridWidth, setGridWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const handleResize = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (gridNode) {
            // setGridWidth(gridNode.clientWidth)
            const style = window.getComputedStyle(gridNode);
            const width = parseInt(style.getPropertyValue("width"));
            const padding = parseInt(style.getPropertyValue("padding-left"));
            setGridWidth(width - padding * 2);
        }
    }, [
        gridNode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        handleResize
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (gridNode) {
            const style = window.getComputedStyle(gridNode);
            const width = parseInt(style.getPropertyValue("width"));
            const padding = parseInt(style.getPropertyValue("padding-left"));
            setGridWidth(width - padding * 2);
        }
    }, [
        gridNode
    ]);
    return {
        gridRef,
        containerRef,
        isSticky,
        gridWidth,
        customTabsRef
    };
};
const Stickable = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { $mobileFullWidth , theme  } = param;
    return $mobileFullWidth ? "\n      ".concat(theme.breakpoints.down("md"), " {\n        margin-left: -").concat(theme.spacing(4), ";\n        margin-right: -").concat(theme.spacing(4), ";\n        padding: 0 ").concat(theme.spacing(4), ";\n        width: 100vw;\n      }\n    ") : "";
}, (param)=>{
    let { $isSticky , $isHideScrollbar =false , $isOverflowVisible , $hasHeader , $hasMarginBottom , $hasBottomShadow , theme , $height , $stickyWidth , $paddingBottom , $bgColor , $zIndex  } = param;
    return $isSticky ? "\n      position: sticky;\n      margin-bottom: ".concat($hasMarginBottom ? theme.spacing(9) : "", ";\n      top: 0;\n      height: ").concat($height ? $height : "", ";\n      width: ").concat($stickyWidth ? $stickyWidth + "px" : "100%", ";\n      max-height: ").concat($hasHeader ? "calc(100vh - ".concat(config_theme__WEBPACK_IMPORTED_MODULE_3__/* .headerHeight */ .J9, ")") : "100vh", ";\n      overflow-y: ").concat($isOverflowVisible ? "visible" : "auto", ";\n      padding-bottom: ").concat($paddingBottom ? "".concat($paddingBottom, "px") : "", ";\n      background-color: ").concat($bgColor ? $bgColor : "", ";\n      box-shadow: ").concat($hasBottomShadow ? "0px 12px 16px 0px #0000001A" : "", ";\n      z-index: ").concat($zIndex ? $zIndex : "auto", ";\n\n      ").concat($isHideScrollbar && "\n        ::-webkit-scrollbar {\n          display: none;\n        }\n      ", "\n      ") : "";
});
/* harmony default export */ __webpack_exports__["Z"] = (Stickable);


/***/ }),

/***/ 11193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VenderContact_ContactPhoneModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./components/common/Modal/index.js
var Modal = __webpack_require__(37524);
// EXTERNAL MODULE: ./components/common/SVGElements/SVG.js
var SVG = __webpack_require__(54806);
;// CONCATENATED MODULE: ./components/common/SVGElements/Phone.js


const PhoneSVG = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* default */.Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "23",
        viewBox: "0 0 24 23",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            d: "M14.062.89a1 1 0 0 1 1.105-.884A10 10 0 0 1 24 8.828a1 1 0 0 1-1.987.224 8 8 0 0 0-7.067-7.058A1 1 0 0 1 14.062.89ZM7.788 3.242A1 1 0 0 0 7.126 3h-3.01a1 1 0 0 0-.994 1.083 18.79 18.79 0 0 0 2.914 8.223l.004.008a18.5 18.5 0 0 0 5.693 5.692l.007.005a18.79 18.79 0 0 0 8.184 2.914 1.001 1.001 0 0 0 1.082-1.001v-3.028a1 1 0 0 0-.856-1.015 13.847 13.847 0 0 1-3.023-.754l-.003-.001a1 1 0 0 0-1.053.223l-1.268 1.268a1 1 0 0 1-1.201.162 17 17 0 0 1-6.375-6.375 1 1 0 0 1 .162-1.201l1.268-1.268a1 1 0 0 0 .223-1.053V6.88a13.84 13.84 0 0 1-.754-3.024 1 1 0 0 0-.338-.614ZM3 11C2 8.5.812 5.68 1 4c.28-2.5 2.271-2.859 3-3h3.006C8.5 1 10 2 10.106 3.58l.002.01c.117.884.333 1.753.645 2.59a3 3 0 0 1-.676 3.163l-.004.004-.717.717a15.002 15.002 0 0 0 4.586 4.586l.717-.717.004-.004a3 3 0 0 1 3.164-.675c.836.311 1.705.528 2.59.645h.009a3 3 0 0 1 2.58 3.032L23 20s-.148 3-3.012 3c-1.291 0-5.668-.767-8.988-3-4-2.5-7-7-7-7m10.075-8.192a1 1 0 0 1 1.173-.79 6 6 0 0 1 4.74 4.74 1 1 0 1 1-1.963.383 4 4 0 0 0-3.16-3.16 1 1 0 0 1-.79-1.173Z",
            className: "Vector (Stroke)",
            clipRule: "evenodd"
        })
    });
};

// EXTERNAL MODULE: ./components/pages/Vender/constants.js
var constants = __webpack_require__(7676);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderContact/ContactPhoneModal.js








const ContactPhoneModal = (param)=>{
    let { open , onClose , phone , extension , shortname , onPhoneClick , onCallClick , phoneLinkId , callButtonId  } = param;
    if (!phone) return null;
    const phoneLink = "tel:".concat(phone).concat(extension ? ",,".concat(extension) : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* InfoModal */.nv, {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                px: 5,
                pt: 5,
                fontWeight: "fontWeightBold",
                children: "廠商聯絡電話"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                p: 5,
                children: constants/* VENDER_AD_WARNING_TEXT */.r
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                alignItems: "center",
                px: 5,
                pb: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneSVG, {
                        $color: "text.minus2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        ml: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(A/* default */.Z, {
                            id: phoneLinkId,
                            href: phoneLink,
                            onClick: onPhoneClick,
                            children: [
                                phone,
                                extension && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: " #".concat(extension)
                                })
                            ]
                        })
                    })
                ]
            }),
            shortname && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                px: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "paraBodySmall",
                    color: "text.minus2",
                    children: [
                        "聯繫時，歡迎告知 ",
                        shortname,
                        " 您是從「信義居家」看到資訊。"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "flex-end",
                gap: 2.5,
                p: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        onClick: onClose,
                        size: "small",
                        sx: {
                            color: "text.minus1",
                            borderColor: "text.minus1"
                        },
                        children: "關閉"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: callButtonId,
                        size: "small",
                        variant: "contained",
                        color: "primary",
                        href: phoneLink,
                        onClick: onCallClick,
                        children: "撥打電話"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var VenderContact_ContactPhoneModal = (ContactPhoneModal);


/***/ }),

/***/ 43231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Vender_VenderContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tabs/Tabs.js + 8 modules
var Tabs = __webpack_require__(62722);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(18661);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(17575);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(32046);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./node_modules/lodash-es/isUndefined.js
var isUndefined = __webpack_require__(49360);
// EXTERNAL MODULE: ./node_modules/lodash-es/orderBy.js
var orderBy = __webpack_require__(3695);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./utils/api/hooks/useLoginData.js
var useLoginData = __webpack_require__(68056);
// EXTERNAL MODULE: ./utils/hooks/fetchers.js
var fetchers = __webpack_require__(86700);
;// CONCATENATED MODULE: ./utils/api/hooks/useVenderByUrlId.js

const useVenderByUrlId = function() {
    let urlId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, swrOptions = arguments.length > 1 ? arguments[1] : void 0;
    return (0,fetchers/* useCustomSWR */.LW)(urlId && "/venders/urlId/".concat(urlId), swrOptions);
};

// EXTERNAL MODULE: ./utils/api/hooks/useAlbumCount.js
var useAlbumCount = __webpack_require__(61908);
// EXTERNAL MODULE: ./utils/api/hooks/useArticleCount.js
var useArticleCount = __webpack_require__(43921);
// EXTERNAL MODULE: ./utils/api/general/setVenderViewedOrClicked.js
var setVenderViewedOrClicked = __webpack_require__(3491);
// EXTERNAL MODULE: ./utils/helpers/vender-welcome-info.js
var vender_welcome_info = __webpack_require__(19575);
// EXTERNAL MODULE: ./utils/helpers/vender-joined-years.js
var vender_joined_years = __webpack_require__(75082);
;// CONCATENATED MODULE: ./utils/helpers/vender-view-page-type.js
const VENDER_VIEW_PAGE_TYPE_BY_PAGE = {
    home: "home",
    about: "companyIntro",
    contact: "contactInfo"
};
const getVenderViewPageType = (pageType)=>VENDER_VIEW_PAGE_TYPE_BY_PAGE[pageType] || VENDER_VIEW_PAGE_TYPE_BY_PAGE.home;
const getVenderViewTrackingParams = (pageType)=>({
        isAddView: true,
        pageType: getVenderViewPageType(pageType)
    });

// EXTERNAL MODULE: ./utils/helpers/index.js
var helpers = __webpack_require__(30905);
// EXTERNAL MODULE: ./utils/native-notifier.js
var native_notifier = __webpack_require__(11634);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
// EXTERNAL MODULE: ./utils/hooks/analytics/constants.js
var constants = __webpack_require__(42395);
;// CONCATENATED MODULE: ./utils/hooks/analytics/GtmAgent/useGtmVenderPageView.js



const useGtmVenderPageView = function(vender) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { enabled =true  } = options;
    const [initialPageViewSent, setInitialPageViewSent] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (enabled && !initialPageViewSent && vender) {
            GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                event: constants/* VENDER_PAGEVIEW */.L_,
                living_partner_id: vender.urlId,
                living_partner_name: vender.name,
                living_partner_catlog: vender.serviceClassifications || []
            });
            setInitialPageViewSent(true);
        }
    }, [
        enabled,
        vender,
        initialPageViewSent
    ]);
};

// EXTERNAL MODULE: ./components/common/Layout/index.js
var Layout = __webpack_require__(82023);
// EXTERNAL MODULE: ./components/common/Header/index.js + 2 modules
var Header = __webpack_require__(75883);
// EXTERNAL MODULE: ./components/common/Footer/index.js + 12 modules
var Footer = __webpack_require__(56007);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./components/common/InfoBlock/index.js
var InfoBlock = __webpack_require__(7739);
// EXTERNAL MODULE: ./components/common/SVGElements/Eye.js
var Eye = __webpack_require__(23183);
// EXTERNAL MODULE: ./components/common/SVGElements/AlertCircle.js
var AlertCircle = __webpack_require__(67749);
// EXTERNAL MODULE: ./components/common/InfiniteContainer/index.js
var InfiniteContainer = __webpack_require__(26643);
// EXTERNAL MODULE: ./components/common/LoginRequiredModal/index.js
var LoginRequiredModal = __webpack_require__(70779);
// EXTERNAL MODULE: ./components/common/Stickable/index.js
var Stickable = __webpack_require__(78098);
// EXTERNAL MODULE: ./components/common/Hidden/index.js
var Hidden = __webpack_require__(18450);
// EXTERNAL MODULE: ./components/common/Modal/index.js
var Modal = __webpack_require__(37524);
// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
;// CONCATENATED MODULE: ./components/common/Tag/index.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n  overflow-y: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}






const OneLineGrid = (0,emotion_styled_browser_esm/* default */.Z)(Grid/* default */.ZP)(_templateObject(), (param)=>{
    let { $height  } = param;
    return $height || "72px";
}, (param)=>{
    let { $width  } = param;
    return $width;
});
// Button 會把小寫轉成大寫，目前不影響
const StyledTag = (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z)(_templateObject1(), (param)=>{
    let { theme , size , shape  } = param;
    return "\n    font-size: 14px;\n    color: ".concat(theme.palette.text.minus2, ";\n    background: ").concat(theme.palette.grey.third, ";\n    padding: ").concat({
        sm: "10px 12px",
        md: "10px 16px",
        lg: "12px 20px",
        xl: "12px 20px"
    }[size], ";\n    border-radius: ").concat({
        round: "20px",
        rectangle: "6px"
    }[shape], ";\n    cursor: default;\n\n    &:hover {\n      background-color: ").concat(theme.palette.primary.bgPlus1, ";\n      box-shadow: none; // shadow override worked here only in ios browser\n    }\n    &:active {\n      background-color: ").concat(theme.palette.primary.main, ";\n      color: #ffffff;\n    }\n  ");
});
const Tag = (param)=>{
    let { children , shape ="round" , size ="md" , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTag, {
        variant: "contained",
        color: "grey",
        shape: shape,
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            sx: {
                typography: {
                    sm: "bodyXs",
                    md: "bodySmall",
                    lg: "bodyMedium",
                    xl: "bodyLarge"
                }[size]
            },
            children: children
        })
    });
};
/* harmony default export */ var common_Tag = (Tag);

// EXTERNAL MODULE: ./components/common/NowrapDiv/index.js
var NowrapDiv = __webpack_require__(2925);
// EXTERNAL MODULE: ./components/common/ResponsiveDiv/index.js
var common_ResponsiveDiv = __webpack_require__(54996);
// EXTERNAL MODULE: ./components/common/ButtonBasic/index.js
var ButtonBasic = __webpack_require__(79450);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./components/common/SVGElements/SVG.js
var SVG = __webpack_require__(54806);
;// CONCATENATED MODULE: ./components/common/SVGElements/Map.js


const MapSVG = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* default */.Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            className: "map",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M8 1a.995.995 0 0 0-.511.14L.504 5.132A1 1 0 0 0 0 6v16a1 1 0 0 0 1.496.868l6.535-3.734 7.504 3.751a.994.994 0 0 0 .976-.026l6.985-3.99A1 1 0 0 0 24 18V2a1 1 0 0 0-1.496-.868l-6.536 3.734-7.503-3.751A.996.996 0 0 0 8 1Zm9 19.277 5-2.857V3.723L17 6.58v13.697ZM15 6.618l-6-3v13.764l6 3V6.618ZM2 6.58l5-2.857V17.42l-5 2.857V6.58Z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/common/SVGElements/Email.js


const EmailSVG = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* default */.Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            className: "mail",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M3.107 5.554C3.272 5.227 3.612 5 4 5h16c.388 0 .728.227.893.554L12 11.779 3.107 5.554ZM1 5.98V18c0 1.652 1.348 3 3 3h16c1.652 0 3-1.348 3-3V6.009m-2 1.912V18c0 .548-.452 1-1 1H4c-.548 0-1-.452-1-1V7.92l8.427 5.9a1 1 0 0 0 1.146 0L21 7.92Zm2-1.935A3.006 3.006 0 0 0 20 3H4a3.006 3.006 0 0 0-3 2.98",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/Vender/VenderRelatedLinks/index.js





const VenderRelatedLinks = (param)=>{
    let { links , vender , clickLocation , onExternalLinkClick , ...boxProps } = param;
    const onLinkClick = (event, link)=>{
        event.preventDefault();
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_otherlink",
            living_click_name: link.name,
            living_click_location: clickLocation,
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
            living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id
        });
        onExternalLinkClick === null || onExternalLinkClick === void 0 ? void 0 : onExternalLinkClick(link.url, link.name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        display: "flex",
        flexWrap: "wrap",
        ...boxProps,
        children: links.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                href: link.url,
                rel: "noopener noreferrer",
                onClick: (event)=>onLinkClick(event, link),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    fontWeight: "fontWeightBold",
                    color: "primary.main",
                    children: link.name
                })
            }, link.id))
    });
};
VenderRelatedLinks.defaultProps = {
    links: []
};
/* harmony default export */ var Vender_VenderRelatedLinks = (VenderRelatedLinks);

// EXTERNAL MODULE: ./components/pages/Vender/constants.js
var Vender_constants = __webpack_require__(7676);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderContact/index.js














const cleanContactText = (value)=>typeof value === "string" ? value.trim() : "";
const buildContactAddress = (vender)=>{
    const address = (vender === null || vender === void 0 ? void 0 : vender.address) || {};
    const county = cleanContactText(address.county);
    const district = cleanContactText(address.district);
    const details = cleanContactText(address.details);
    if (!(vender === null || vender === void 0 ? void 0 : vender.isAddressPublic) || !county || !district || !details) return null;
    const text = "".concat(county).concat(district).concat(details);
    return {
        text,
        mapUrl: cleanContactText(vender === null || vender === void 0 ? void 0 : vender.mapLink) || "https://www.google.com/maps/search/?api=1&query=".concat(encodeURIComponent(text))
    };
};
const buildContactLinks = (vender)=>{
    var _vender_introductionInfo;
    return ((vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo = vender.introductionInfo) === null || _vender_introductionInfo === void 0 ? void 0 : _vender_introductionInfo.urls) || []).map((item, index)=>({
            id: item.id || item._id || "contact-link-".concat(index),
            name: cleanContactText(item.name),
            url: cleanContactText(item.url)
        })).filter((item)=>item.name && item.url).slice(0, 10);
};
const normalizeVenderContactData = function() {
    let { vender ={}  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _vender_contactInfoSetting, _vender_contactInfoSetting_phone, _vender_contactInfoSetting1, _vender_contactInfoSetting_phone1, _vender_contactInfoSetting2, _vender_contactInfoSetting_email;
    return {
        phone: cleanContactText(vender === null || vender === void 0 ? void 0 : (_vender_contactInfoSetting = vender.contactInfoSetting) === null || _vender_contactInfoSetting === void 0 ? void 0 : (_vender_contactInfoSetting_phone = _vender_contactInfoSetting.phone) === null || _vender_contactInfoSetting_phone === void 0 ? void 0 : _vender_contactInfoSetting_phone.number),
        extension: cleanContactText(vender === null || vender === void 0 ? void 0 : (_vender_contactInfoSetting1 = vender.contactInfoSetting) === null || _vender_contactInfoSetting1 === void 0 ? void 0 : (_vender_contactInfoSetting_phone1 = _vender_contactInfoSetting1.phone) === null || _vender_contactInfoSetting_phone1 === void 0 ? void 0 : _vender_contactInfoSetting_phone1.extension),
        email: cleanContactText(vender === null || vender === void 0 ? void 0 : (_vender_contactInfoSetting2 = vender.contactInfoSetting) === null || _vender_contactInfoSetting2 === void 0 ? void 0 : (_vender_contactInfoSetting_email = _vender_contactInfoSetting2.email) === null || _vender_contactInfoSetting_email === void 0 ? void 0 : _vender_contactInfoSetting_email.address),
        address: buildContactAddress(vender),
        links: buildContactLinks(vender)
    };
};
const hasVenderContactContent = (data)=>{
    var _data_links;
    return Boolean((data === null || data === void 0 ? void 0 : data.phone) || (data === null || data === void 0 ? void 0 : data.email) || (data === null || data === void 0 ? void 0 : data.address) || (data === null || data === void 0 ? void 0 : (_data_links = data.links) === null || _data_links === void 0 ? void 0 : _data_links.length));
};
const DetailButton = (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        minWidth: 0,
        fontSize: theme.typography.body1.fontSize,
        fontWeight: theme.typography.fontWeightBold
    };
});
const ContactRow = (param)=>/*#__PURE__*/ {
    let { label , children , alignItems ="center"  } = param;
    return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        alignItems: alignItems,
        gap: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                fontWeight: "fontWeightBold",
                color: "text.minus1",
                whiteSpace: "nowrap",
                flexShrink: 0,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                minWidth: 0,
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                columnGap: 1,
                children: children
            })
        ]
    });
};
const VenderContact = (param)=>{
    let { data , vender , loggedIn , onPhoneDetailClick , onLoginRequired , onExternalLinkClick  } = param;
    var _data_links;
    const [isEmailModalOpen, setEmailModalOpen] = (0,react.useState)(false);
    const onPhoneDetailButtonClick = ()=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_contact",
            living_click_name: "聯絡電話-查看詳情",
            living_click_location: "廠商聯繫資訊頁",
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
            living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id
        });
        onPhoneDetailClick === null || onPhoneDetailClick === void 0 ? void 0 : onPhoneDetailClick();
    };
    const onEmailDetailClick = ()=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_mail",
            living_click_name: "公司信箱-查看詳情",
            living_click_location: "廠商聯繫資訊頁",
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
            living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id
        });
        if (loggedIn) {
            setEmailModalOpen(true);
        } else {
            onLoginRequired === null || onLoginRequired === void 0 ? void 0 : onLoginRequired();
        }
    };
    const onMapClick = ()=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_map",
            living_click_name: "公司地址-查看詳情",
            living_click_location: "廠商聯繫資訊頁",
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
            living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mb: 18,
        display: "flex",
        flexDirection: "column",
        rowGap: 2.5,
        children: [
            !!(data === null || data === void 0 ? void 0 : data.phone) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactRow, {
                label: "聯絡電話",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailButton, {
                    variant: "text",
                    disableRipple: true,
                    onClick: onPhoneDetailButtonClick,
                    children: "查看詳情"
                })
            }),
            !!(data === null || data === void 0 ? void 0 : data.email) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactRow, {
                label: "公司信箱",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailButton, {
                    variant: "text",
                    disableRipple: true,
                    onClick: onEmailDetailClick,
                    children: "查看詳情"
                })
            }),
            !!(data === null || data === void 0 ? void 0 : data.address) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactRow, {
                label: "公司地址",
                alignItems: "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                    component: "span",
                    color: "text.minus1",
                    minWidth: 0,
                    sx: {
                        overflowWrap: "anywhere",
                        wordBreak: "break-word"
                    },
                    children: [
                        data.address.text.slice(0, -1),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            component: "span",
                            whiteSpace: "nowrap",
                            children: [
                                data.address.text.slice(-1),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    component: "a",
                                    href: data.address.mapUrl,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    "aria-label": "在 Google 地圖查看",
                                    size: "small",
                                    sx: {
                                        p: 0,
                                        ml: 2,
                                        verticalAlign: "middle"
                                    },
                                    onClick: onMapClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MapSVG, {
                                        primary: true,
                                        width: "24",
                                        height: "24"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            !!(data === null || data === void 0 ? void 0 : (_data_links = data.links) === null || _data_links === void 0 ? void 0 : _data_links.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactRow, {
                label: "相關連結",
                alignItems: "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Vender_VenderRelatedLinks, {
                    links: data.links,
                    vender: vender,
                    clickLocation: "廠商聯繫資訊頁",
                    onExternalLinkClick: onExternalLinkClick,
                    gap: 4
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* InfoModal */.nv, {
                open: isEmailModalOpen,
                onClose: ()=>setEmailModalOpen(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        px: 5,
                        pt: 5,
                        fontWeight: "fontWeightBold",
                        children: "廠商聯絡信箱"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        p: 5,
                        children: Vender_constants/* VENDER_AD_WARNING_TEXT */.r
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        alignItems: "center",
                        px: 5,
                        pb: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSVG, {
                                $color: "text.minus2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                ml: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                    href: "mailto:".concat(data === null || data === void 0 ? void 0 : data.email),
                                    children: data === null || data === void 0 ? void 0 : data.email
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        px: 5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                            variant: "paraBodySmall",
                            color: "text.minus2",
                            children: [
                                "聯絡時，歡迎告知 ",
                                vender === null || vender === void 0 ? void 0 : vender.shortname,
                                " 您是從「信義居家」看到資訊。"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "flex",
                        justifyContent: "flex-end",
                        p: 5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBasic/* default */.Z, {
                            variant: "outlined",
                            size: "medium",
                            color: "neutral",
                            onClick: ()=>setEmailModalOpen(false),
                            children: "關閉"
                        })
                    })
                ]
            })
        ]
    });
};
VenderContact.defaultProps = {
    data: {},
    loggedIn: false
};
/* harmony default export */ var Vender_VenderContact = (VenderContact);

// EXTERNAL MODULE: ./components/pages/Vender/VenderContact/ContactPhoneModal.js + 1 modules
var ContactPhoneModal = __webpack_require__(11193);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/VenderServiceInfoSimplified.js




const VenderServiceInfoSimplified = (param)=>{
    let { vender  } = param;
    var _vender_introductionInfo, _vender_introductionInfo_serviceCounties;
    // 若後台設定廠商列表篩選項目為 true 才顯示
    const visibleServiceItems = ((vender === null || vender === void 0 ? void 0 : vender.venderServiceItems) || []).map((serviceItem)=>{
        var _serviceItem_serviceClassification, _serviceItem_serviceClassification1;
        return (serviceItem === null || serviceItem === void 0 ? void 0 : (_serviceItem_serviceClassification = serviceItem.serviceClassification) === null || _serviceItem_serviceClassification === void 0 ? void 0 : _serviceItem_serviceClassification.isVenderFilterListVisible) ? serviceItem === null || serviceItem === void 0 ? void 0 : (_serviceItem_serviceClassification1 = serviceItem.serviceClassification) === null || _serviceItem_serviceClassification1 === void 0 ? void 0 : _serviceItem_serviceClassification1.name : null;
    }).filter(Boolean);
    const infos = [];
    // 服務項目
    if (visibleServiceItems.length) {
        infos.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    minWidth: 66,
                    fontWeight: "fontWeightBold",
                    color: "text.minus2",
                    style: {
                        lineHeight: "24px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                        children: "服務項目"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    ml: 4,
                    flexGrow: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        style: {
                            lineHeight: "24px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            color: "text.minus2",
                            children: visibleServiceItems.join(" / ")
                        })
                    })
                })
            ]
        }));
    }
    // 服務區域
    if (vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo = vender.introductionInfo) === null || _vender_introductionInfo === void 0 ? void 0 : (_vender_introductionInfo_serviceCounties = _vender_introductionInfo.serviceCounties) === null || _vender_introductionInfo_serviceCounties === void 0 ? void 0 : _vender_introductionInfo_serviceCounties.length) {
        var _vender_introductionInfo1, _vender_introductionInfo_serviceCounties1;
        infos.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    minWidth: 66,
                    fontWeight: "fontWeightBold",
                    color: "text.minus2",
                    style: {
                        lineHeight: "24px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                        children: "服務區域"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    ml: 4,
                    flexGrow: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        style: {
                            lineHeight: "24px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            color: "text.minus2",
                            children: vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo1 = vender.introductionInfo) === null || _vender_introductionInfo1 === void 0 ? void 0 : (_vender_introductionInfo_serviceCounties1 = _vender_introductionInfo1.serviceCounties) === null || _vender_introductionInfo_serviceCounties1 === void 0 ? void 0 : _vender_introductionInfo_serviceCounties1.join("、")
                        })
                    })
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: infos.map((info, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 3,
                children: info
            }, "info-".concat(index)))
    });
};
/* harmony default export */ var VenderContent_VenderServiceInfoSimplified = (VenderServiceInfoSimplified);

// EXTERNAL MODULE: ./components/common/HTMLContent/index.js
var HTMLContent = __webpack_require__(47216);
;// CONCATENATED MODULE: ./components/common/SVGElements/DoubleQuotes1.js


const DoubleQuotes1SVG = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* default */.Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "12",
        fill: "none",
        viewBox: "0 0 13 12",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            className: "double_quotation_marks_left",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#9B9B9B",
                d: "M1.632 0c1.056.704 2.256 1.168 3.6 1.392.128.32.224.784.288 1.392.096.608.128 1.136.096 1.584-1.408.096-2.112.88-2.112 2.352 0 .64.176 1.408.528 2.304.384.896.832 1.696 1.344 2.4-.224.16-.528.288-.912.384-.384.096-.704.128-.96.096A15.223 15.223 0 0 1 .912 7.92C.304 6.448 0 5.024 0 3.648 0 1.92.544.704 1.632 0Zm7.104.144c.96.672 2.176 1.136 3.648 1.392.128.32.224.768.288 1.344.096.544.128 1.04.096 1.488-1.472.096-2.208.88-2.208 2.352 0 .608.176 1.344.528 2.208a17.67 17.67 0 0 0 1.344 2.4c-.224.16-.528.288-.912.384-.352.096-.672.128-.96.096-1.088-1.248-1.936-2.56-2.544-3.936-.608-1.376-.912-2.736-.912-4.08 0-1.76.544-2.976 1.632-3.648Z",
                className: "quotes1"
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/common/SVGElements/DoubleQuotes2.js


const DoubleQuotes2SVG = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SVG/* default */.Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "12",
        fill: "none",
        viewBox: "0 0 13 12",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                className: "double_quotation_marks_right",
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#9B9B9B",
                    d: "M11.148 11.916c-1.056-.704-2.256-1.168-3.6-1.392-.128-.32-.224-.784-.288-1.392-.096-.608-.128-1.136-.096-1.584 1.408-.096 2.112-.88 2.112-2.352 0-.64-.176-1.408-.528-2.304a12.302 12.302 0 0 0-1.344-2.4c.224-.16.528-.288.912-.384.384-.096.704-.128.96-.096a15.224 15.224 0 0 1 2.592 3.984c.608 1.472.912 2.896.912 4.272 0 1.728-.544 2.944-1.632 3.648Zm-7.104-.144c-.96-.672-2.176-1.136-3.648-1.392-.128-.32-.224-.768-.288-1.344a6.103 6.103 0 0 1-.096-1.488c1.472-.096 2.208-.88 2.208-2.352 0-.608-.176-1.344-.528-2.208A17.67 17.67 0 0 0 .348.588C.572.428.876.3 1.26.204c.352-.096.672-.128.96-.096 1.088 1.248 1.936 2.56 2.544 3.936.608 1.376.912 2.736.912 4.08 0 1.76-.544 2.976-1.632 3.648Z",
                    className: "quotes2"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "a",
                    className: "a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h13v12H0z"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/Multiline.js

const Multiline = (param)=>{
    let { text  } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: text === null || text === void 0 ? void 0 : text.split("\n").map((line, index)=>/*#__PURE__*/ _jsx("div", {
                children: line
            }, "line-".concat(index)))
    });
};
/* harmony default export */ var VenderContent_Multiline = ((/* unused pure expression or super */ null && (Multiline)));

// EXTERNAL MODULE: ./components/common/Present/index.js
var Present = __webpack_require__(99469);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/VenderIntro.js






const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(ResponsiveDiv, {
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "h3",
            children: children
        })
    });
};
const VenderIntro = (param)=>{
    let { venderIntroduction , containerId  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
        children: venderIntroduction === null || venderIntroduction === void 0 ? void 0 : venderIntroduction.map((module)=>{
            return !(module === null || module === void 0 ? void 0 : module.isVisible) ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: (module === null || module === void 0 ? void 0 : module.type) === "graphicMore" || (module === null || module === void 0 ? void 0 : module.type) === "publicitySmall" || (module === null || module === void 0 ? void 0 : module.type) === "banner" ? {
                    xs: 12,
                    md: 18
                } : {
                    xs: 18,
                    md: 24
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Present/* default */.Z, {
                    data: module,
                    isServicePage: true,
                    lazy: false,
                    lazyOptions: {
                        containerId
                    }
                }, module === null || module === void 0 ? void 0 : module._id)
            });
        })
    });
};
/* harmony default export */ var VenderContent_VenderIntro = (VenderIntro);

;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/Company.js

function Company_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  top: 10px;\n"
    ]);
    Company_templateObject = function() {
        return data;
    };
    return data;
}
function Company_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: 10px;\n"
    ]);
    Company_templateObject1 = function() {
        return data;
    };
    return data;
}










const DoubleQuotes1 = (0,emotion_styled_browser_esm/* default */.Z)(DoubleQuotes1SVG)(Company_templateObject());
const DoubleQuotes2 = (0,emotion_styled_browser_esm/* default */.Z)(DoubleQuotes2SVG)(Company_templateObject1());
const Company = (param)=>{
    let { vender , containerId  } = param;
    var _vender_introductionInfo, _vender_introductionInfo_venderIntroduction, _vender_introductionInfo1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!(vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo = vender.introductionInfo) === null || _vender_introductionInfo === void 0 ? void 0 : (_vender_introductionInfo_venderIntroduction = _vender_introductionInfo.venderIntroduction) === null || _vender_introductionInfo_venderIntroduction === void 0 ? void 0 : _vender_introductionInfo_venderIntroduction.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_VenderIntro, {
            venderIntroduction: vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo1 = vender.introductionInfo) === null || _vender_introductionInfo1 === void 0 ? void 0 : _vender_introductionInfo1.venderIntroduction,
            containerId: containerId
        })
    });
};
/* harmony default export */ var VenderContent_Company = (Company);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandLess.js
var ExpandLess = __webpack_require__(60181);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/DiscountInfoBlock.js








const collapsedLineCount = 2;
const useIsomorphicLayoutEffect =  false ? 0 : react.useLayoutEffect;
const DiscountInfoBlock = (param)=>{
    let { vender , expanded: controlledExpanded , onExpandedChange , ...rest } = param;
    const [uncontrolledExpanded, setUncontrolledExpanded] = (0,react.useState)(false);
    const [isOverflow, setIsOverflow] = (0,react.useState)(false);
    const textRef = (0,react.useRef)(null);
    const { favorableDiscountText: discountText  } = (0,vender_welcome_info/* getVenderWelcomeInfo */.u)(vender);
    const expanded = controlledExpanded !== null && controlledExpanded !== void 0 ? controlledExpanded : uncontrolledExpanded;
    const toggleExpanded = ()=>{
        const nextExpanded = !expanded;
        if (onExpandedChange) {
            onExpandedChange(nextExpanded);
        } else {
            setUncontrolledExpanded(nextExpanded);
        }
    };
    useIsomorphicLayoutEffect(()=>{
        const textElement = textRef.current;
        if (!discountText || !textElement) return;
        const updateOverflow = ()=>{
            const style = window.getComputedStyle(textElement);
            const fontSize = parseFloat(style.fontSize) || 14;
            const lineHeight = parseFloat(style.lineHeight) || fontSize * 1.5;
            const collapsedHeight = lineHeight * collapsedLineCount;
            setIsOverflow(textElement.scrollHeight > collapsedHeight + 1);
        };
        updateOverflow();
        if (typeof window.ResizeObserver === "undefined") {
            window.addEventListener("resize", updateOverflow);
            return ()=>window.removeEventListener("resize", updateOverflow);
        }
        const resizeObserver = new window.ResizeObserver(updateOverflow);
        resizeObserver.observe(textElement);
        return ()=>resizeObserver.disconnect();
    }, [
        discountText
    ]);
    if (!discountText) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBlock/* default */.Z, {
        px: 5,
        py: 5,
        $radius: 6,
        ...rest,
        sx: {
            height: "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        color: "text.minus2",
                        fontWeight: "fontWeightBold",
                        children: "特色優惠"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                ref: textRef,
                component: "div",
                variant: "paraBodySmall",
                color: "text.minus2",
                sx: {
                    mt: 2,
                    lineHeight: 1.5,
                    display: "-webkit-box",
                    WebkitLineClamp: expanded ? "unset" : collapsedLineCount,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all"
                },
                children: discountText
            }),
            (isOverflow || expanded) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                alignItems: "center",
                onClick: toggleExpanded,
                width: "fit-content",
                mt: 2,
                sx: {
                    cursor: "pointer"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "paraBodySmall",
                        color: "primary.mainPlus2",
                        children: expanded ? "收合" : "展開"
                    }),
                    expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {
                        sx: {
                            color: "primary.mainPlus2",
                            fontSize: 24
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                        sx: {
                            color: "primary.mainPlus2",
                            fontSize: 24
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var VenderContent_DiscountInfoBlock = (DiscountInfoBlock);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(20724);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(13379);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
// EXTERNAL MODULE: ./components/common/Banner/DesktopPaginationWithTitle.js
var DesktopPaginationWithTitle = __webpack_require__(44395);
// EXTERNAL MODULE: ./components/common/Banner/StyledSwiper.js
var StyledSwiper = __webpack_require__(98121);
// EXTERNAL MODULE: ./components/common/Banner/index.js
var Banner = __webpack_require__(25820);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/sendBannerClick.js
var sendBannerClick = __webpack_require__(24994);
// EXTERNAL MODULE: ./utils/api/general/genPathByNavData.js
var genPathByNavData = __webpack_require__(39086);
// EXTERNAL MODULE: ./utils/hooks/useBannerGA.js + 1 modules
var useBannerGA = __webpack_require__(778);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/VenderBannerCarousel.js

function VenderBannerCarousel_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    VenderBannerCarousel_templateObject = function() {
        return data;
    };
    return data;
}

















const modules = [
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Autoplay */.pt,
    swiper_esm/* Lazy */.oM
];
const Img = (0,emotion_styled_browser_esm/* default */.Z)(Banner/* BannerImg */.tS)(VenderBannerCarousel_templateObject(), (param)=>{
    let { theme , $clickable  } = param;
    return "\n    min-height: unset;\n    object-fit: cover;\n    cursor: ".concat($clickable ? "pointer" : "default", ";\n    aspect-ratio: 3 / 2;\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      aspect-ratio: 4 / 1;\n    }\n  ");
});
const swiperSettings = {
    spaceBetween: 24,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    pagination: {
        el: ".banner-pagination",
        clickable: true
    },
    slideToClickedSlide: true
};
const swiperAutoplay = {
    delay: 5000,
    disableOnInteraction: false
};
const BannerSlide = (param)=>{
    let { banner , onBannerClick , isFirst , isMobile  } = param;
    var _banner_mobileImage, _banner_image, _banner_image1, _banner_mobileImage1, _banner_navData;
    const src = isMobile ? (banner === null || banner === void 0 ? void 0 : (_banner_mobileImage = banner.mobileImage) === null || _banner_mobileImage === void 0 ? void 0 : _banner_mobileImage.url) || (banner === null || banner === void 0 ? void 0 : (_banner_image = banner.image) === null || _banner_image === void 0 ? void 0 : _banner_image.url) : (banner === null || banner === void 0 ? void 0 : (_banner_image1 = banner.image) === null || _banner_image1 === void 0 ? void 0 : _banner_image1.url) || (banner === null || banner === void 0 ? void 0 : (_banner_mobileImage1 = banner.mobileImage) === null || _banner_mobileImage1 === void 0 ? void 0 : _banner_mobileImage1.url);
    const isClickable = (banner === null || banner === void 0 ? void 0 : (_banner_navData = banner.navData) === null || _banner_navData === void 0 ? void 0 : _banner_navData.page) !== "default";
    if (!src) return null;
    return isFirst || !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
        src: src,
        $clickable: isClickable,
        onClick: isClickable ? onBannerClick : undefined
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
        "data-src": src,
        $clickable: isClickable,
        onClick: isClickable ? onBannerClick : undefined,
        className: "swiper-lazy"
    });
};
const VenderBannerCarousel = (param)=>{
    let { banners , isMobile , venderName , venderId  } = param;
    var _safeBanners_, _safeBanners_1, _safeBanners_2;
    const [swiper, setSwiper] = (0,react.useState)(null);
    const [swiperIndex, setSwiperIndex] = (0,react.useState)(0);
    const [hovered, setHovered] = (0,react.useState)(false);
    const theme = (0,useTheme/* default */.Z)();
    const isDesktop = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    const safeBanners = Array.isArray(banners) ? banners.filter((banner)=>{
        var _banner_image, _banner_mobileImage;
        return (banner === null || banner === void 0 ? void 0 : (_banner_image = banner.image) === null || _banner_image === void 0 ? void 0 : _banner_image.url) || (banner === null || banner === void 0 ? void 0 : (_banner_mobileImage = banner.mobileImage) === null || _banner_mobileImage === void 0 ? void 0 : _banner_mobileImage.url);
    }) : [];
    const onNextClick = ()=>{
        return swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
    };
    const onPrevClick = ()=>{
        return swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
    };
    const onIndexChange = (s)=>{
        if (s.realIndex > -1) setSwiperIndex(s.realIndex);
    };
    const onPaginationIndexClick = (index)=>{
        return swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(safeBanners.length + index);
    };
    const onBannerClick = (banner)=>{
        return async ()=>{
            (0,sendBannerClick/* sendBannerClick */.y)({
                banner,
                bannerLocation: "廠商首頁",
                venderName,
                venderId
            });
            const { path , isExternalLink  } = await (0,genPathByNavData/* genPathByNavData */.E)(banner === null || banner === void 0 ? void 0 : banner.navData);
            if (path) {
                const url = !isExternalLink && /^\/service\//.test(path) ? "".concat(path).concat(path.includes("?") ? "&" : "?", "preselect_vender=").concat(venderId) : path;
                window.open(url, "_blank");
            }
        };
    };
    (0,useBannerGA/* useBannerGAForCarousel */.a)({
        bannerData: safeBanners,
        bannerLocation: "廠商首頁",
        venderName,
        venderId,
        swiper,
        isRepeated: false
    });
    (0,useBannerGA/* useBannerGAForCarousel */.a)({
        bannerData: safeBanners,
        bannerLocation: "廠商首頁",
        venderName,
        venderId,
        swiper,
        isRepeated: true
    });
    if (!safeBanners.length) return null;
    const swiperNavigation = {
        nextEl: ".vender-banner-instance-".concat((_safeBanners_ = safeBanners[0]) === null || _safeBanners_ === void 0 ? void 0 : _safeBanners_._id, " .banner-swiper-next"),
        prevEl: ".vender-banner-instance-".concat((_safeBanners_1 = safeBanners[0]) === null || _safeBanners_1 === void 0 ? void 0 : _safeBanners_1._id, " .banner-swiper-prev")
    };
    const swiperLazyOptions = isMobile ? {
        loadOnTransitionStart: true,
        loadPrevNext: true
    } : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mb: 18,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            onMouseEnter: ()=>setHovered(true),
            onMouseLeave: ()=>setHovered(false),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwiper/* StyledSwiper */.W, {
                modules: modules,
                ...swiperSettings,
                preloadImages: !isMobile,
                lazy: swiperLazyOptions,
                watchSlidesProgress: isMobile,
                loopedSlides: safeBanners.length,
                navigation: safeBanners.length > 1 ? swiperNavigation : false,
                autoplay: safeBanners.length > 1 ? swiperAutoplay : false,
                onAfterInit: (s)=>setSwiper(s),
                onRealIndexChange: onIndexChange,
                children: [
                    safeBanners.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            hovered && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: "vender-banner-instance-".concat((_safeBanners_2 = safeBanners[0]) === null || _safeBanners_2 === void 0 ? void 0 : _safeBanners_2._id),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "banner-swiper-next",
                                        onClick: onNextClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "banner-swiper-prev",
                                        onClick: onPrevClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "banner-pagination"
                            })
                        ]
                    }),
                    safeBanners.map((banner, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSlide, {
                                banner: banner,
                                isMobile: isMobile,
                                isFirst: index === 0,
                                onBannerClick: onBannerClick(banner)
                            })
                        }, banner._id || index)),
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopPaginationWithTitle/* default */.Z, {
                        data: safeBanners,
                        currentIndex: swiperIndex,
                        onPaginationIndexClick: onPaginationIndexClick
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var VenderContent_VenderBannerCarousel = (VenderBannerCarousel);

;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/VenderServiceIntro.js








const VenderServiceIntro = (param)=>{
    let { serviceIntro  } = param;
    var _serviceIntro_image, _serviceIntro_image1;
    const [expanded, setExpanded] = (0,react.useState)(false);
    const [isOverflow, setIsOverflow] = (0,react.useState)(false);
    const [mounted, setMounted] = (0,react.useState)(false);
    const textRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        setMounted(true);
    }, []);
    (0,react.useEffect)(()=>{
        if (!textRef.current) return;
        setIsOverflow(textRef.current.scrollHeight > textRef.current.clientHeight);
    }, [
        serviceIntro === null || serviceIntro === void 0 ? void 0 : serviceIntro.description,
        mounted
    ]);
    if (!(serviceIntro === null || serviceIntro === void 0 ? void 0 : serviceIntro.description) && !(serviceIntro === null || serviceIntro === void 0 ? void 0 : (_serviceIntro_image = serviceIntro.image) === null || _serviceIntro_image === void 0 ? void 0 : _serviceIntro_image.url)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mb: 18,
        display: "flex",
        flexDirection: {
            xs: "column",
            md: "row"
        },
        alignItems: {
            xs: "flex-start",
            md: "center"
        },
        justifyContent: "space-between",
        gap: {
            xs: 5,
            md: 12
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                gap: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ResponsiveDiv/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            children: "服務介紹"
                        })
                    }),
                    !!(serviceIntro === null || serviceIntro === void 0 ? void 0 : serviceIntro.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                ref: textRef,
                                variant: "paraBodyMedium",
                                color: "text.minus2",
                                sx: mounted ? {
                                    display: "-webkit-box",
                                    WebkitLineClamp: expanded ? "unset" : 10,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-all"
                                } : {
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-all"
                                },
                                children: serviceIntro.description
                            }),
                            (isOverflow || expanded) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                alignItems: "center",
                                onClick: ()=>setExpanded((prev)=>!prev),
                                width: "fit-content",
                                mt: 2,
                                sx: {
                                    cursor: "pointer"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "paraBodyMedium",
                                        color: "primary.mainPlus2",
                                        children: expanded ? "收合" : "查看完整資訊"
                                    }),
                                    expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {
                                        sx: {
                                            color: "primary.mainPlus2",
                                            fontSize: 20
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                                        sx: {
                                            color: "primary.mainPlus2",
                                            fontSize: 20
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!(serviceIntro === null || serviceIntro === void 0 ? void 0 : (_serviceIntro_image1 = serviceIntro.image) === null || _serviceIntro_image1 === void 0 ? void 0 : _serviceIntro_image1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                flexShrink: 0,
                position: "relative",
                sx: {
                    width: {
                        xs: "100%",
                        md: "calc(40% - 48px)"
                    },
                    aspectRatio: "3/2",
                    borderRadius: "24px",
                    overflow: "hidden",
                    bgcolor: "#d9d9d9"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: serviceIntro.image.url,
                    fill: true,
                    style: {
                        objectFit: "cover"
                    },
                    alt: "服務介紹圖片"
                })
            })
        ]
    });
};
/* harmony default export */ var VenderContent_VenderServiceIntro = (VenderServiceIntro);

;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/VenderServiceItems.js

function VenderServiceItems_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 12px;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 0px 8px rgba(0, 0, 0, 0.05);\n  ",
        "\n"
    ]);
    VenderServiceItems_templateObject = function() {
        return data;
    };
    return data;
}
function VenderServiceItems_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: 4px 8px;\n  border-radius: 12px 0 12px 0;\n  background-color: ",
        ";\n  color: white;\n"
    ]);
    VenderServiceItems_templateObject1 = function() {
        return data;
    };
    return data;
}










const CardWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$hasLink"
})(VenderServiceItems_templateObject(), (param)=>{
    let { $hasLink  } = param;
    return $hasLink ? "\n    cursor: pointer;\n    &:hover {\n      img {\n        transform: scale(1.1);\n      }\n    }\n  " : "";
});
const LabelChip = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(VenderServiceItems_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.palette.secondary.minus2;
});
const ServiceItemCard = (param)=>{
    let { item , onCardClick  } = param;
    var _item_navData, _item_image;
    // 除了不送出點擊動作以外，其他類型都有動作前往其他頁面，因此只要判斷 page 即可
    const hasLink = !!(item === null || item === void 0 ? void 0 : (_item_navData = item.navData) === null || _item_navData === void 0 ? void 0 : _item_navData.page) && item.navData.page !== "default";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, {
        $hasLink: hasLink,
        onClick: hasLink ? onCardClick : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                position: "relative",
                overflow: "hidden",
                sx: {
                    aspectRatio: "3/2",
                    flexShrink: 0
                },
                children: [
                    (item === null || item === void 0 ? void 0 : (_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: item.image.url,
                        fill: true,
                        style: {
                            objectFit: "cover",
                            transition: "transform 0.3s ease"
                        },
                        className: hasLink ? "service-item-img" : undefined,
                        alt: item.title || "",
                        quality: 75
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: "100%",
                        height: "100%",
                        bgcolor: "#d9d9d9"
                    }),
                    !!(item === null || item === void 0 ? void 0 : item.tag) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelChip, {
                        children: item.tag
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                px: 4,
                pt: 4,
                pb: 5,
                display: "flex",
                flexDirection: "column",
                gap: 4,
                flexGrow: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "titleMedium",
                        color: "text.minus1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                            $lines: 3,
                            children: item === null || item === void 0 ? void 0 : item.title
                        })
                    }),
                    !!(item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "bodyMedium",
                        color: "text.minus2",
                        sx: {
                            wordBreak: "break-all"
                        },
                        children: item.description
                    })
                ]
            })
        ]
    });
};
const VenderServiceItems = (param)=>{
    let { serviceItems , venderName , venderId  } = param;
    const safeServiceItems = Array.isArray(serviceItems) ? serviceItems.filter((item)=>item && typeof item === "object") : [];
    if (!safeServiceItems.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        gap: 6,
        mb: 18,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ResponsiveDiv/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    children: "服務項目"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                rowSpacing: {
                    xs: 4,
                    md: 8
                },
                columnSpacing: {
                    xs: 4,
                    lg: 6,
                    xxl: 8
                },
                children: safeServiceItems.slice(0, 8).map((item, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 6,
                        md: 3,
                        display: "flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceItemCard, {
                            item: item,
                            onCardClick: async ()=>{
                                GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                                    event: "living_action",
                                    living_event_name: "vender_service_item",
                                    living_click_name: item === null || item === void 0 ? void 0 : item.title,
                                    living_click_location: "廠商首頁",
                                    living_click_id: item === null || item === void 0 ? void 0 : item._id,
                                    living_vender: venderName,
                                    living_vender_id: venderId
                                });
                                if (item === null || item === void 0 ? void 0 : item.navData) {
                                    const result = await (0,genPathByNavData/* genPathByNavData */.E)(item.navData);
                                    if (result === null || result === void 0 ? void 0 : result.path) {
                                        const url = !result.isExternalLink && /^\/service\//.test(result.path) ? "".concat(result.path).concat(result.path.includes("?") ? "&" : "?", "preselect_vender=").concat(venderId) : result.path;
                                        window.open(url, "_blank");
                                    }
                                }
                            }
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var VenderContent_VenderServiceItems = (VenderServiceItems);

;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/VenderServiceFlows.js

function VenderServiceFlows_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 36px;\n  height: 36px;\n  border-radius: 12px 0 12px 0;\n  background-color: ",
        ";\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ",
        "\n"
    ]);
    VenderServiceFlows_templateObject = function() {
        return data;
    };
    return data;
}
function VenderServiceFlows_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f6f6f6;\n  border-radius: 12px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    VenderServiceFlows_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-wrap: anywhere;\n  word-break: break-word;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}







const StepBadge = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(VenderServiceFlows_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.palette.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.typography.headlineSmall;
});
const StepCard = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(VenderServiceFlows_templateObject1());
const StepTitle = (0,emotion_styled_browser_esm/* default */.Z)(NowrapDiv/* default */.Z)(_templateObject2());
const ServiceFlowCard = (param)=>{
    let { item , index  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                alignItems: "flex-start",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StepBadge, {
                        children: index + 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "flex",
                        alignItems: "center",
                        flex: 1,
                        minWidth: 0,
                        pt: 1.5,
                        pr: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "titleLarge",
                            color: "primary.main",
                            lineHeight: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepTitle, {
                                $lines: 2,
                                children: item === null || item === void 0 ? void 0 : item.title
                            })
                        })
                    })
                ]
            }),
            !!(item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                px: "20px",
                pb: "20px",
                pt: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body1",
                    color: "text.minus2",
                    style: {
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        lineHeight: 1.5
                    },
                    children: item.description
                })
            })
        ]
    });
};
const VenderServiceFlows = (param)=>{
    let { serviceFlows  } = param;
    const safeServiceFlows = Array.isArray(serviceFlows) ? serviceFlows.filter((item)=>item && typeof item === "object") : [];
    if (!safeServiceFlows.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mb: 18,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ResponsiveDiv/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    pb: 6,
                    children: "服務流程"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: 6,
                alignItems: "stretch",
                children: safeServiceFlows.slice(0, 8).map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        lg: 3,
                        display: "flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceFlowCard, {
                                item: item,
                                index: index
                            })
                        })
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var VenderContent_VenderServiceFlows = (VenderServiceFlows);

;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/VenderWhyChooseUs.js





const VenderWhyChooseUs = (param)=>{
    let { reasons , image  } = param;
    const safeReasons = Array.isArray(reasons) ? reasons.filter((item)=>item && typeof item === "object") : [];
    if (!safeReasons.length && !(image === null || image === void 0 ? void 0 : image.url)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            mb: 18,
            display: "flex",
            flexDirection: {
                xs: "column",
                md: "row"
            },
            justifyContent: "space-between",
            alignItems: {
                xs: "stretch",
                md: "center"
            },
            gap: {
                xs: 6,
                md: 12
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ResponsiveDiv/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                color: "text.minus1",
                                children: "選擇我們的理由"
                            })
                        }),
                        safeReasons.map((item, index)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/img/lightbulb.svg",
                                                alt: "",
                                                width: 24,
                                                height: 24
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "titleLarge",
                                                color: "text.minus1",
                                                sx: {
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 1,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden"
                                                },
                                                children: item === null || item === void 0 ? void 0 : item.title
                                            })
                                        ]
                                    }),
                                    !!(item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "paraBodySmall",
                                        color: "text.secondary",
                                        children: item.description
                                    })
                                ]
                            }, index);
                        })
                    ]
                }),
                !!(image === null || image === void 0 ? void 0 : image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    flexShrink: 0,
                    position: "relative",
                    sx: {
                        width: {
                            xs: "100%",
                            md: "calc(40% - 48px)"
                        },
                        aspectRatio: "3/2",
                        borderRadius: "24px",
                        overflow: "hidden",
                        bgcolor: "#d9d9d9"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image.url,
                        fill: true,
                        style: {
                            objectFit: "cover"
                        },
                        alt: "選擇我們的理由"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var VenderContent_VenderWhyChooseUs = (VenderWhyChooseUs);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ChevronLeft.js
var ChevronLeft = __webpack_require__(19572);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ChevronRight.js
var ChevronRight = __webpack_require__(26215);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/VenderCertification.js












const getCarouselPageIndex = (swiper, direction)=>{
    const { activeIndex , slidesGrid , width  } = swiper;
    const currentPosition = slidesGrid[activeIndex];
    if (direction === "previous") {
        const targetPosition = Math.max(currentPosition - width, 0);
        for(let index = activeIndex - 1; index >= 0; index -= 1){
            if (slidesGrid[index] <= targetPosition) return index;
        }
        return 0;
    }
    const targetPosition1 = currentPosition + width;
    const nextIndex = slidesGrid.findIndex((position, index)=>index > activeIndex && position >= targetPosition1);
    return nextIndex === -1 ? slidesGrid.length - 1 : nextIndex;
};
const VenderCertification = (param)=>{
    let { sinyiLivingCertification  } = param;
    const items = (sinyiLivingCertification === null || sinyiLivingCertification === void 0 ? void 0 : sinyiLivingCertification.items) || [];
    const swiperRef = (0,react.useRef)(null);
    const [isAtStart, setIsAtStart] = (0,react.useState)(true);
    const [isAtEnd, setIsAtEnd] = (0,react.useState)(items.length <= 3);
    const theme = (0,useTheme/* default */.Z)();
    const isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    const updateNavigationState = (swiper)=>{
        setIsAtStart(swiper.isBeginning);
        setIsAtEnd(swiper.isEnd);
    };
    if (!(sinyiLivingCertification === null || sinyiLivingCertification === void 0 ? void 0 : sinyiLivingCertification.isVisible) || !items.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mb: 18,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mb: 4.5,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: "信義居家認證合作廠商"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: items.length > 3 && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    gap: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            "aria-label": "上一排信義居家認證標章",
                                            onClick: ()=>{
                                                const swiper = swiperRef.current;
                                                if (!swiper) return;
                                                swiper.slideTo(getCarouselPageIndex(swiper, "previous"));
                                            },
                                            disabled: isAtStart,
                                            size: "small",
                                            sx: {
                                                borderRadius: "24px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            "aria-label": "下一排信義居家認證標章",
                                            onClick: ()=>{
                                                const swiper = swiperRef.current;
                                                if (!swiper) return;
                                                swiper.slideTo(getCarouselPageIndex(swiper, "next"));
                                            },
                                            disabled: isAtEnd,
                                            size: "small",
                                            sx: {
                                                borderRadius: "24px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {})
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "paraBodyMedium",
                        component: "div",
                        color: "text.minus2",
                        children: [
                            "本廠商通過信義居家合作審核機制，具備",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                component: "span",
                                variant: "paraBodyMedium",
                                color: "primary.main",
                                children: "合法登記、專業資格與良好商譽"
                            }),
                            "，並經",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                component: "span",
                                variant: "paraBodyMedium",
                                color: "primary.main",
                                children: "每年定期審查"
                            }),
                            "，持續符合服務品質標準。審查通過者將獲頒當年度「信義居家認證合作廠商標章」，一眼辨識、安心選擇。"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mr: {
                    xs: -4,
                    lg: -9,
                    xl: -12,
                    xxl: -16
                },
                overflow: "hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    slidesPerView: "auto",
                    spaceBetween: 16,
                    slidesOffsetAfter: 0,
                    threshold: 8,
                    grabCursor: true,
                    simulateTouch: true,
                    allowTouchMove: true,
                    watchOverflow: true,
                    breakpoints: {
                        768: {
                            spaceBetween: 16,
                            slidesOffsetAfter: 16
                        },
                        992: {
                            spaceBetween: 16,
                            slidesOffsetAfter: 36
                        },
                        1200: {
                            spaceBetween: 24,
                            slidesOffsetAfter: 48
                        },
                        1600: {
                            spaceBetween: 32,
                            slidesOffsetAfter: 64
                        }
                    },
                    onSwiper: (swiper)=>{
                        swiperRef.current = swiper;
                        updateNavigationState(swiper);
                    },
                    onSlideChange: updateNavigationState,
                    onReachBeginning: updateNavigationState,
                    onReachEnd: updateNavigationState,
                    onFromEdge: updateNavigationState,
                    onResize: updateNavigationState,
                    style: {
                        overflow: "visible"
                    },
                    children: items.map((item, index)=>{
                        var _item_image;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            style: {
                                width: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                width: {
                                    xs: "70vw",
                                    sm: "36vw",
                                    md: "25vw",
                                    xxl: "400px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    p: 3,
                                    borderRadius: "16px",
                                    sx: {
                                        aspectRatio: "1 / 1"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        position: "relative",
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                        children: (item === null || item === void 0 ? void 0 : (_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: item.image.url,
                                            fill: true,
                                            draggable: false,
                                            sizes: "(max-width: 575px) 70vw, (max-width: 767px) 36vw, (max-width: 1600px) 25vw, 400px",
                                            style: {
                                                objectFit: "contain"
                                            },
                                            alt: item.alt || ""
                                        })
                                    })
                                })
                            })
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var VenderContent_VenderCertification = (VenderCertification);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(41470);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(22841);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(8519);
// EXTERNAL MODULE: ./store/cache/cacheSlice.js
var cacheSlice = __webpack_require__(24363);
// EXTERNAL MODULE: ./utils/api/hooks/useVenderSupportItems.js
var useVenderSupportItems = __webpack_require__(56724);
;// CONCATENATED MODULE: ./utils/api/hooks/useVenderOrderService.js

const useVenderOrderService = (param)=>{
    let { venderId  } = param;
    const result = (0,useVenderSupportItems/* useVenderSupportItems */.q)({
        target: "orderService",
        venderId
    });
    if (result === null || result === void 0 ? void 0 : result.data) return {
        ...result,
        data: result.data
    };
    return result;
};

;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/Controls.js

function Controls_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Controls_templateObject = function() {
        return data;
    };
    return data;
}



















const StyleWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(Controls_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      margin: 0;\n      width: 724px;\n      height: 444px;\n      border-radius: 10px;\n    }\n  ");
});
const Controls = (param)=>{
    let { vender , $height , isMobileByWidth , onExternalLinkClick  } = param;
    var _supportServicesData_orderServices, _vender_navData;
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const [serviceModal, setServiceModal] = (0,react.useState)({
        open: false
    });
    const [selectedService, setSelectedService] = (0,react.useState)(null);
    const { serviceItem  } = router.query;
    const { data: supportServicesData  } = useVenderOrderService({
        venderId: vender === null || vender === void 0 ? void 0 : vender._id
    });
    const serviceOptions = (supportServicesData === null || supportServicesData === void 0 ? void 0 : (_supportServicesData_orderServices = supportServicesData.orderServices) === null || _supportServicesData_orderServices === void 0 ? void 0 : _supportServicesData_orderServices.map((service)=>({
            serviceId: service._id,
            serviceName: service.name,
            identityCode: service.identityCode
        }))) || [];
    // venderServiceItems 廠商介紹資訊的服務項目，會大於等於 serviceOptions = 有效派案與廠商介紹資訊的服務項目的交集
    // 等於的話，相當於沒有額外的服務項目
    const isHintVisible = serviceOptions.length < (vender === null || vender === void 0 ? void 0 : vender.venderServiceItems.length);
    // 預選服務
    (0,react.useEffect)(()=>{
        if (serviceItem && serviceOptions.length > 1 && !selectedService) {
            const preSelectedService = serviceOptions.find((service)=>service.serviceId === serviceItem);
            if (preSelectedService) {
                setSelectedService(preSelectedService);
            }
        }
    }, [
        serviceItem,
        serviceOptions
    ]);
    const handleReservation = async (service)=>{
        var _vender_navData;
        dispatch((0,cacheSlice/* setNavigateInfo */.nb)({
            id: vender._id,
            type: "Vender"
        }));
        if (!!(vender === null || vender === void 0 ? void 0 : (_vender_navData = vender.navData) === null || _vender_navData === void 0 ? void 0 : _vender_navData.page)) {
            var _vender_navData1;
            if ((vender === null || vender === void 0 ? void 0 : (_vender_navData1 = vender.navData) === null || _vender_navData1 === void 0 ? void 0 : _vender_navData1.action) === "venderProvideServiceJudgment") {
                dispatch((0,cacheSlice/* setPreselectVender */.bE)(vender._id));
                router.push("/service/".concat(service === null || service === void 0 ? void 0 : service.identityCode, "/booking"));
            } else {
                GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                    event: "living_action",
                    living_event_name: "booking_to_link",
                    living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
                    living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id,
                    living_click_name: (vender === null || vender === void 0 ? void 0 : vender.gotoReservationDefaultName) || "點我前往",
                    living_click_location: "廠商頁"
                });
                const { path , isExternalLink  } = await (0,genPathByNavData/* genPathByNavData */.E)(vender.navData);
                if (!path) return;
                // 有連結則確認是否為居家 domain
                if (isExternalLink) {
                    if (onExternalLinkClick) {
                        const buttonName = vender.gotoReservationDefaultName || "透過信義居家預約";
                        onExternalLinkClick(path, buttonName);
                    } else {
                        window.open(path, "_blank");
                    }
                    return;
                }
                if (/^\/service\//.test(path)) {
                    dispatch((0,cacheSlice/* setPreselectVender */.bE)(vender._id));
                }
                router.push(path);
            }
        } else {
            router.push("/");
        }
    };
    const openServiceModal = ()=>setServiceModal({
            open: true
        });
    const closeServiceModal = ()=>setServiceModal({
            open: false
        });
    const handleConfirm = ()=>{
        if (selectedService) {
            handleReservation(selectedService);
            GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                event: "living_action",
                living_event_name: "booking_service",
                living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id,
                living_click_name: (vender === null || vender === void 0 ? void 0 : vender.gotoReservationDefaultName) || "透過信義居家預約",
                living_click_location: "廠商頁彈窗-預約服務",
                living_vender_service: selectedService.serviceName,
                living_vender: vender === null || vender === void 0 ? void 0 : vender.name
            });
            closeServiceModal();
        }
    };
    const handleServiceChange = (event)=>{
        const serviceObject = serviceOptions.find((option)=>option.serviceId === event.target.value);
        setSelectedService(serviceObject);
    };
    const handleButtonClick = ()=>{
        var _vender_navData;
        if ((vender === null || vender === void 0 ? void 0 : (_vender_navData = vender.navData) === null || _vender_navData === void 0 ? void 0 : _vender_navData.action) === "venderProvideServiceJudgment") {
            if (serviceOptions.length === 1) {
                handleReservation(serviceOptions[0]);
                GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                    event: "living_action",
                    living_event_name: "booking_service",
                    living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id,
                    living_click_name: (vender === null || vender === void 0 ? void 0 : vender.gotoReservationDefaultName) || "透過信義居家預約",
                    living_click_location: "廠商頁",
                    living_vender_service: serviceOptions[0].serviceName,
                    living_vender: vender === null || vender === void 0 ? void 0 : vender.name
                });
            } else {
                openServiceModal();
            }
        } else {
            handleReservation();
        }
    };
    // 只有當有服務選項時才顯示按鈕
    if ((vender === null || vender === void 0 ? void 0 : (_vender_navData = vender.navData) === null || _vender_navData === void 0 ? void 0 : _vender_navData.action) === "venderProvideServiceJudgment" && !serviceOptions.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "book",
                        className: "action",
                        variant: "contained",
                        color: "primary",
                        fullWidth: true,
                        onClick: handleButtonClick,
                        sx: {
                            fontSize: "18px",
                            height: $height ? "".concat($height) : "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                            children: vender.gotoReservationDefaultName || "透過信義居家預約"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* FunctionModal */.rK, {
                open: serviceModal.open,
                onClose: closeServiceModal,
                ModalWrapper: StyleWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    p: 5,
                    gap: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            display: "flex",
                            justifyContent: isMobileByWidth ? "center" : "flex-start",
                            position: "relative",
                            pb: isMobileByWidth ? 5 : 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "titleLarge",
                                color: "text.minus1",
                                children: "預約服務"
                            })
                        }),
                        isHintVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "paraBodyMedium",
                            color: "text.minus1",
                            children: "*部分服務項目未提供線上預約功能，因此未顯示於此，需自行聯絡廠商"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* ScrollableBox */.N1, {
                            flexGrow: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                                value: (selectedService === null || selectedService === void 0 ? void 0 : selectedService.serviceId) || "",
                                onChange: handleServiceChange,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    container: true,
                                    columnSpacing: isMobileByWidth ? 0 : 5,
                                    children: serviceOptions.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: isMobileByWidth ? 12 : 6,
                                            sx: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                value: option.serviceId,
                                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                    sx: {
                                                        padding: 0
                                                    }
                                                }),
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "paraBodyMedium",
                                                    color: "text.minus2",
                                                    marginLeft: 2.5,
                                                    children: option.serviceName
                                                }),
                                                sx: {
                                                    width: "100%",
                                                    padding: "10px 15px",
                                                    margin: 0,
                                                    display: "flex",
                                                    alignItems: "center"
                                                }
                                            })
                                        }, option.serviceId))
                                })
                            })
                        }),
                        isMobileByWidth ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 2.5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBasic/* default */.Z, {
                                        variant: "outlined",
                                        fullWidth: true,
                                        onClick: closeServiceModal,
                                        size: "large",
                                        color: "neutral",
                                        children: "關閉"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBasic/* default */.Z, {
                                        variant: "contained",
                                        fullWidth: true,
                                        onClick: handleConfirm,
                                        disabled: !selectedService,
                                        size: "large",
                                        color: "primary",
                                        children: "確認"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 2.5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBasic/* default */.Z, {
                                        variant: "outlined",
                                        onClick: closeServiceModal,
                                        size: "medium",
                                        color: "neutral",
                                        children: "關閉"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBasic/* default */.Z, {
                                    variant: "contained",
                                    onClick: handleConfirm,
                                    disabled: !selectedService,
                                    size: "medium",
                                    color: "primary",
                                    children: "確認"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var VenderContent_Controls = (Controls);

;// CONCATENATED MODULE: ./components/pages/Vender/VenderContent/index.js

function VenderContent_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-width: 1472px;\n  aspect-ratio: 3;\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    VenderContent_templateObject = function() {
        return data;
    };
    return data;
}
function VenderContent_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: ",
        "px;\n  width: ",
        "px;\n\n  ",
        "\n"
    ]);
    VenderContent_templateObject1 = function() {
        return data;
    };
    return data;
}
function VenderContent_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  border: ",
        "px solid white;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: white;\n"
    ]);
    VenderContent_templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  width: ",
        "px;\n  height: ",
        "px;\n  object-fit: cover;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  right: 0;\n  // 為了創造靠右效果故+16px\n  width: calc(100% + 16px);\n  display: flex;\n  justify-content: left;\n  flex-wrap: nowrap;\n  gap: 8px;\n  overflow: auto;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}






















































const DynamicAlbums = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(168), __webpack_require__.e(9469)]).then(__webpack_require__.bind(__webpack_require__, 89469)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(89469)
            ]
    }
});
const DynamicArticles = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(168), __webpack_require__.e(4668)]).then(__webpack_require__.bind(__webpack_require__, 4668)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4668)
            ]
    }
});
const DynamicVenderAbout = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8126).then(__webpack_require__.bind(__webpack_require__, 8126)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8126)
            ]
    }
});
const VenderContent_useIsomorphicLayoutEffect =  false ? 0 : react.useLayoutEffect;
let pendingVenderTabScrollPosition = null;
// 由於廠商代表圖於廠商頁面改版後在 mobile 需滿版，故從 ContentWrapper 抽離並客製化
const ImgWrapper = emotion_styled_browser_esm/* default.div */.Z.div(VenderContent_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      width: calc(100% - ").concat(theme.spacing(18), ");\n      aspect-ratio: 4;\n      border-radius: 4px;\n    }\n    ").concat(theme.breakpoints.up("xl"), " {\n      width: calc(100% - ").concat(theme.spacing(24), ");\n    }\n    ").concat(theme.breakpoints.up("xxl"), " {\n      width: calc(100% - ").concat(theme.spacing(32), ");\n    }\n  ");
});
const avatarSize = 100;
const avatarBorderSize = 0;
const AvatarRelativeWrapper = emotion_styled_browser_esm/* default.div */.Z.div(VenderContent_templateObject1(), (param)=>{
    let { $withTypicalImage  } = param;
    return Math.floor($withTypicalImage ? avatarSize / 2 : avatarSize) + avatarBorderSize * 2;
}, avatarSize + avatarBorderSize * 2, (param)=>{
    let { theme , $withTypicalImage  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      height: ").concat(avatarSize + avatarBorderSize * 2 - ($withTypicalImage ? 40 : 0), "px;\n    }\n  ");
});
const AvatarWrapper = emotion_styled_browser_esm/* default.div */.Z.div(VenderContent_templateObject2(), avatarBorderSize);
const Avatar = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject3(), avatarSize, avatarSize);
const JoinYearsTooltip = (0,emotion_styled_browser_esm/* default */.Z)((param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        ...props,
        classes: {
            popper: className
        }
    });
})((param)=>{
    let { theme  } = param;
    return {
        ["& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip)]: {
            borderRadius: "4px",
            padding: "10px",
            backgroundColor: theme.palette.text.minus1,
            color: theme.palette.white.contrastText,
            ...theme.typography.paraBodyXs
        }
    };
});
const CustomTabs = (0,emotion_styled_browser_esm/* default */.Z)(Tabs/* default */.Z)(_templateObject4(), (param)=>{
    let { theme  } = param;
    return "\n    .MuiTabs-indicator {\n      height: 4px;\n    }\n    .MuiTabs-indicatorSpan {\n      width: 32px;\n      border-radius: 4px;\n      background: ".concat(theme.palette.primary.main, ";\n    }\n    .MuiTabs-flexContainer {\n      gap: 24px;\n    }\n  ");
});
const CustomTab = (0,emotion_styled_browser_esm/* default */.Z)(Tab/* default */.Z)(_templateObject5(), (param)=>{
    let { theme  } = param;
    return "\n    &.MuiTab-root {\n      min-width: unset;\n      padding: 14px 0;\n      font-size: ".concat(theme.typography.body1.fontSize, ";\n      font-weight: initial;\n      color: ").concat(theme.palette.text.minus2, ";\n\n      &.Mui-selected {\n        font-weight: 700;\n        color: ").concat(theme.palette.primary.main, ";\n      }\n    }\n  ");
});
const NameWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6(), (param)=>{
    let { theme , $withTypicalImage  } = param;
    return "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    // ".concat(theme.breakpoints.up("lg"), " {\n    //   justify-content: flex-start;\n    //   align-items: ").concat($withTypicalImage ? "flex-start" : "center", ";\n    //   margin-bottom: 0;\n    //   margin-top: ").concat(theme.spacing($withTypicalImage ? 9 : 0), ";\n    //   flex-grow: 1;\n    // }\n  ");
});
const VenderFeatureTagWrapperForMobile = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject7());
// 首頁資訊會有預覽需求，多一層轉換函式以確保相關區塊資料結構的正確性
const toArray = (value)=>Array.isArray(value) ? value : [];
const toObjectArray = (value)=>toArray(value).filter((item)=>item && typeof item === "object");
const VenderContent = (param)=>{
    let { isMobile , fallbackData , pageType , previewHomepageSetting , previewWelcomeInfoSetting , previewContactInfoSetting , previewCompanyIntroSetting , topNotice  } = param;
    var _vender_ownQualityTag, _homepageData_serviceIntroduction, _vender_introductionInfo, _vender_introductionInfo1, _vender_introductionInfo2, _vender_viewPage, _venderWhyChooseUs_reasons;
    const { loggedIn  } = (0,useLoginData/* useLoginData */.Q)();
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    const theme = (0,useTheme/* default */.Z)();
    const currentPageType = [
        "about",
        "contact"
    ].includes(pageType) ? pageType : "home";
    const { gridRef , containerRef , customTabsRef , isSticky  } = (0,Stickable/* useCustomSticky */.Y)();
    // 用寬度判斷是否為 mobile。isMobile 則以裝置類型判斷
    const isMobileByWidth = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const invokeNativeHeaderControls = ()=>{
        try {
            (0,native_notifier/* enableNativeHeaderMainTabs */.QL)(true);
            (0,native_notifier/* enableNativeHeaderNavBack */.Gz)(true);
            (0,native_notifier/* enableNativeHeaderSearch */.PP)(false);
        } catch (err) {
            console.error("native notifier error: ", err.message);
        }
    };
    (0,react.useEffect)(()=>{
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
            invokeNativeHeaderControls();
        }
    }, [
        webview
    ]);
    (0,react.useEffect)(()=>{
        // 處理列表點進廠商時，隱藏廠商沒有跳轉的問題
        if ((0,isUndefined/* default */.Z)(fallbackData)) location.reload();
    }, []);
    const venderUrlId = fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.venderUrlId;
    const restorePendingTabScrollPosition = (0,react.useCallback)(()=>{
        const pendingPosition = pendingVenderTabScrollPosition;
        const scrollContainer = containerRef.current;
        if (!pendingPosition || pendingPosition.venderUrlId !== venderUrlId || pendingPosition.pageType !== currentPageType) {
            return;
        }
        const { scrollTop  } = pendingPosition;
        const applyScrollPosition = (container)=>{
            if (!container || pendingVenderTabScrollPosition !== pendingPosition) {
                return;
            }
            pendingVenderTabScrollPosition = null;
            container.scrollTop = scrollTop;
            window.requestAnimationFrame(()=>{
                if (containerRef.current === container) {
                    container.scrollTop = scrollTop;
                }
            });
        };
        if (scrollContainer) {
            applyScrollPosition(scrollContainer);
            return;
        }
        window.requestAnimationFrame(()=>{
            applyScrollPosition(containerRef.current);
        });
    }, [
        containerRef,
        currentPageType,
        venderUrlId
    ]);
    VenderContent_useIsomorphicLayoutEffect(()=>{
        if (currentPageType !== "about") {
            restorePendingTabScrollPosition();
        }
    }, [
        currentPageType,
        restorePendingTabScrollPosition
    ]);
    const { data: vender  } = useVenderByUrlId(venderUrlId, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.vender
    });
    const venderWithWelcomePreview = (0,react.useMemo)(()=>{
        if ((0,isUndefined/* default */.Z)(previewWelcomeInfoSetting) || !vender) return vender;
        return {
            ...vender,
            welcomeInfoSetting: previewWelcomeInfoSetting
        };
    }, [
        previewWelcomeInfoSetting,
        vender
    ]);
    (0,react.useEffect)(()=>{
        if (vender === null || vender === void 0 ? void 0 : vender._id) {
            (0,setVenderViewedOrClicked/* setVenderViewedOrClicked */.Y)(vender._id, getVenderViewTrackingParams(currentPageType));
        }
    }, [
        currentPageType,
        vender === null || vender === void 0 ? void 0 : vender._id
    ]);
    const { data: albumCount  } = (0,useAlbumCount/* useAlbumCount */.i)(()=>{
        return (vender === null || vender === void 0 ? void 0 : vender._id) ? {
            venderId: vender === null || vender === void 0 ? void 0 : vender._id
        } : null;
    }, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.albumCount
    });
    const { data: articleCount  } = (0,useArticleCount/* useArticleCount */.T)(()=>{
        return (vender === null || vender === void 0 ? void 0 : vender._id) ? {
            venderId: vender === null || vender === void 0 ? void 0 : vender._id
        } : null;
    }, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.articleCount
    });
    const [isContactNumberModalOpen, setContactNumberModalOpen] = (0,react.useState)(false);
    const [isLoginModalOpen, setLoginModalOpen] = (0,react.useState)(false);
    const [isJoinYearsModalOpen, setJoinYearsModalOpen] = (0,react.useState)(false);
    const [isDiscountExpanded, setDiscountExpanded] = (0,react.useState)(false);
    const openContactNumberModal = ()=>{
        if (loggedIn) {
            setContactNumberModalOpen(true);
        } else {
            setLoginModalOpen(true);
        }
    };
    const onContactNumberBtnClick = ()=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_contact",
            living_click_name: "聯絡電話",
            living_click_location: "廠商頁",
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
            living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id
        });
        openContactNumberModal();
    };
    const onContactNumberModalClose = ()=>setContactNumberModalOpen(false);
    const onLoginModalClose = ()=>setLoginModalOpen(false);
    const onDialNumberClick = ()=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_contact",
            living_click_name: "電話號碼",
            living_click_location: "光箱頁-廠商連絡電話",
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
            living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id
        });
    };
    const onDialButtonClick = ()=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_contact",
            living_click_name: "撥打電話",
            living_click_location: "光箱頁-廠商連絡電話",
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
            living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id
        });
    };
    const handleLogin = ()=>{
        const redirectUrl = window.location.href;
        window.location.href = "/login?rt=".concat(encodeURIComponent(redirectUrl));
    };
    const [linkConfirmation, setLinkConfirmation] = (0,react.useState)({
        isOpen: false,
        url: "",
        name: ""
    });
    const isLivingLifeDomain = (url)=>{
        // 避免資料型態造成後續流程中斷
        if (!url || typeof url !== "string") return true;
        // 檢查是否為相對路徑或錨點連結
        if (url.startsWith("//") || url.startsWith("/") || url.startsWith("#")) {
            return true;
        }
        try {
            const hostname = new URL(url).hostname;
            return hostname.endsWith(".livinglife.com.tw") || hostname === "livinglife.com.tw";
        } catch (e) {
            // 避免後續流程中斷
            return true;
        }
    };
    const handleExternalLinkClick = (url, name)=>{
        if (isLivingLifeDomain(url)) {
            window.open(url, "_blank");
        } else {
            setLinkConfirmation({
                isOpen: true,
                url,
                name
            });
        }
    };
    // 自動關閉不送 GA
    const closeLinkConfirmation = ()=>{
        setLinkConfirmation({
            isOpen: false,
            url: "",
            name: ""
        });
    };
    // 主動關閉則送 GA
    const handleCloseLinkConfirmation = ()=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_non_ls_link_alert",
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
            living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id,
            living_external_link_name: linkConfirmation.name,
            living_click_name: "關閉",
            living_click_location: "廠商頁彈窗-前往連結"
        });
        closeLinkConfirmation();
    };
    const proceedWithExternalLink = ()=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_non_ls_link_alert",
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
            living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id,
            living_external_link_name: linkConfirmation.name,
            living_click_name: "前往",
            living_click_location: "廠商頁彈窗-前往連結"
        });
        window.open(linkConfirmation.url, "_blank", "noopener,noreferrer");
        closeLinkConfirmation();
    };
    useGtmVenderPageView(vender);
    const containerId = "vender-intro-container";
    const { logoImage , typicalImage , typicalMobileImage , announcementText , favorableDiscountText  } = (0,vender_welcome_info/* getVenderWelcomeInfo */.u)(venderWithWelcomePreview);
    const hasTypicalImage = !!(typicalImage === null || typicalImage === void 0 ? void 0 : typicalImage.url);
    const hasTypicalMobileImage = !!(typicalMobileImage === null || typicalMobileImage === void 0 ? void 0 : typicalMobileImage.url);
    const hasLogo = !!(logoImage === null || logoImage === void 0 ? void 0 : logoImage.url);
    const visibleVenderFeatureTag = ((vender === null || vender === void 0 ? void 0 : (_vender_ownQualityTag = vender.ownQualityTag) === null || _vender_ownQualityTag === void 0 ? void 0 : _vender_ownQualityTag.qualityTags) || []).filter((tag)=>tag.isVisible);
    const hasVisibleVenderFeatureTag = visibleVenderFeatureTag.length > 0;
    const sortedVisibleVenderFeatureTag = (0,orderBy/* default */.Z)(visibleVenderFeatureTag, [
        "sort",
        "createdAt"
    ], [
        "desc",
        "desc"
    ]);
    const isGoToReservationBtnShown = !!(vender === null || vender === void 0 ? void 0 : vender.isDisplayGotoReservation);
    const isAlbumMoreThanDisplayNum = albumCount > (isMobileByWidth ? 6 : 8);
    const isArticleMoreThanDisplayNum = articleCount > 4;
    const homepageData = (0,isUndefined/* default */.Z)(previewHomepageSetting) ? vender === null || vender === void 0 ? void 0 : vender.homepageSetting : previewHomepageSetting;
    const venderBanners = toObjectArray(homepageData === null || homepageData === void 0 ? void 0 : homepageData.banners);
    const venderServiceIntro = (homepageData === null || homepageData === void 0 ? void 0 : (_homepageData_serviceIntroduction = homepageData.serviceIntroduction) === null || _homepageData_serviceIntroduction === void 0 ? void 0 : _homepageData_serviceIntroduction.introduction) ? {
        description: homepageData.serviceIntroduction.introduction,
        image: homepageData.serviceIntroduction.image
    } : null;
    const venderServiceItems = toObjectArray(homepageData === null || homepageData === void 0 ? void 0 : homepageData.serviceItems).map((item)=>{
        return {
            ...item,
            tag: item === null || item === void 0 ? void 0 : item.tagWord
        };
    });
    const venderServiceFlows = toObjectArray(homepageData === null || homepageData === void 0 ? void 0 : homepageData.serviceFlow);
    const venderWhyChooseUs = (homepageData === null || homepageData === void 0 ? void 0 : homepageData.chooseUsReasons) ? {
        reasons: toObjectArray(homepageData.chooseUsReasons.chooseUsReasonsContents),
        image: homepageData.chooseUsReasons.image
    } : null;
    const venderSinyiLivingCertification = vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo = vender.introductionInfo) === null || _vender_introductionInfo === void 0 ? void 0 : _vender_introductionInfo.sinyiLivingCertification;
    const isAboutPage = currentPageType === "about";
    const venderWithAboutPreview = (0,react.useMemo)(()=>{
        if ((0,isUndefined/* default */.Z)(previewCompanyIntroSetting) || !vender) return vender;
        return {
            ...vender,
            companyIntroSetting: previewCompanyIntroSetting
        };
    }, [
        previewCompanyIntroSetting,
        vender
    ]);
    const resolvedAboutData = venderWithAboutPreview === null || venderWithAboutPreview === void 0 ? void 0 : venderWithAboutPreview.companyIntroSetting;
    const hasAbout = (0,helpers/* hasVenderAboutContent */.wb)(resolvedAboutData);
    const venderWithContactPreview = (0,react.useMemo)(()=>{
        if ((0,isUndefined/* default */.Z)(previewContactInfoSetting) || !vender) return vender;
        return {
            ...vender,
            contactInfoSetting: previewContactInfoSetting
        };
    }, [
        previewContactInfoSetting,
        vender
    ]);
    const resolvedContactData = (0,react.useMemo)(()=>normalizeVenderContactData({
            vender: venderWithContactPreview
        }), [
        venderWithContactPreview
    ]);
    const hasContact = hasVenderContactContent(resolvedContactData);
    const isContactPage = currentPageType === "contact";
    const joinYears = (0,vender_joined_years/* getVenderJoinedYears */.L)(vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo1 = vender.introductionInfo) === null || _vender_introductionInfo1 === void 0 ? void 0 : _vender_introductionInfo1.joinedSinyiLivingDate);
    var _vender_viewPage_all;
    const pageViews = (vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo2 = vender.introductionInfo) === null || _vender_introductionInfo2 === void 0 ? void 0 : _vender_introductionInfo2.joinedSinyiLivingDate) ? (_vender_viewPage_all = vender === null || vender === void 0 ? void 0 : (_vender_viewPage = vender.viewPage) === null || _vender_viewPage === void 0 ? void 0 : _vender_viewPage.all) !== null && _vender_viewPage_all !== void 0 ? _vender_viewPage_all : 0 : 0;
    // 判斷是否使用新版版面：homepageSetting 中任一區塊有資料即啟用
    const hasNewLayout = !!(venderBanners.length || venderServiceIntro || venderServiceItems.length || venderServiceFlows.length || (venderWhyChooseUs === null || venderWhyChooseUs === void 0 ? void 0 : (_venderWhyChooseUs_reasons = venderWhyChooseUs.reasons) === null || _venderWhyChooseUs_reasons === void 0 ? void 0 : _venderWhyChooseUs_reasons.length));
    const tabClickLocation = {
        about: "廠商公司介紹頁",
        contact: "廠商聯繫資訊頁",
        home: "廠商首頁"
    }[currentPageType];
    const sendTabGtmEvent = (clickName)=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_tab",
            living_click_name: clickName,
            living_click_location: tabClickLocation,
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name,
            living_vender_id: vender === null || vender === void 0 ? void 0 : vender._id
        });
    };
    const onVenderTabClick = (event, clickName, destinationPageType)=>{
        const isNormalNavigation = event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
        if (isNormalNavigation && destinationPageType !== currentPageType && containerRef.current) {
            pendingVenderTabScrollPosition = {
                venderUrlId,
                pageType: destinationPageType,
                scrollTop: containerRef.current.scrollTop
            };
        }
        sendTabGtmEvent(clickName);
    };
    const onShowAllAlbumsBtnClick = ()=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_photoalbum",
            living_click_name: "顯示全部".concat(albumCount, "本相簿"),
            living_click_location: "廠商頁",
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name
        });
        const newUrl = "".concat(window.location.origin, "/album?venderId=").concat(vender._id);
        window.open(newUrl, "_blank", "noopener,noreferrer");
    };
    const onShowAllArticlesBtnClick = ()=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_article",
            living_click_name: "顯示全部".concat(articleCount, "篇文章"),
            living_click_location: "廠商頁",
            living_vender: vender === null || vender === void 0 ? void 0 : vender.name
        });
        const newUrl = "".concat(window.location.origin, "/article/vender-id/").concat(vender._id);
        window.open(newUrl, "_blank", "noopener,noreferrer");
    };
    const contactPhone = resolvedContactData.phone;
    const contactExtension = resolvedContactData.extension;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        stickyHeader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
        // 手機版的前往預約按鈕
        stickyFooter: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInDesktopBox */.aI, {
            bgcolor: "white",
            p: 5,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                children: [
                    !!contactPhone && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "contact",
                        className: "action",
                        variant: "outlined",
                        color: "primary",
                        // 目前無法讓兩個按鍵均分寬度，所以先設定 93% 寬度，之後可能要從 Controls 元件去調整
                        sx: {
                            width: "93%",
                            height: "54px",
                            fontSize: "18px"
                        },
                        onClick: onContactNumberBtnClick,
                        children: "聯絡電話"
                    }),
                    isGoToReservationBtnShown && /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_Controls, {
                        vender: vender,
                        isMobileByWidth: isMobileByWidth,
                        onExternalLinkClick: handleExternalLinkClick
                    })
                ]
            })
        }),
        fixContentHeight: true,
        children: [
            topNotice,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfiniteContainer/* default */.Z, {
                id: containerId,
                containerRef: containerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* InfoModal */.nv, {
                        open: linkConfirmation.isOpen,
                        onClose: closeLinkConfirmation,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "titleLarge",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    p: 5,
                                    children: "前往連結"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                p: 5,
                                children: Vender_constants/* VENDER_AD_WARNING_TEXT */.r
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                justifyContent: "flex-end",
                                p: 5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        mr: 2.5,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBasic/* default */.Z, {
                                            variant: "outlined",
                                            size: "medium",
                                            color: "neutral",
                                            onClick: handleCloseLinkConfirmation,
                                            children: "關閉"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBasic/* default */.Z, {
                                        variant: "contained",
                                        size: "medium",
                                        color: "primary",
                                        onClick: proceedWithExternalLink,
                                        children: "前往"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPhoneModal/* default */.Z, {
                        open: isContactNumberModalOpen,
                        onClose: onContactNumberModalClose,
                        phone: contactPhone,
                        extension: contactExtension,
                        shortname: vender === null || vender === void 0 ? void 0 : vender.shortname,
                        onPhoneClick: onDialNumberClick,
                        onCallClick: onDialButtonClick,
                        phoneLinkId: "dial_number",
                        callButtonId: "dial_btn"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginRequiredModal/* default */.Z, {
                        open: isLoginModalOpen,
                        onClose: onLoginModalClose,
                        onLogin: handleLogin
                    }),
                    !isMobileByWidth && hasTypicalImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        lineHeight: 1,
                        display: "flex",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: typicalImage.url,
                                style: {
                                    objectFit: "cover"
                                },
                                fill: true,
                                priority: true,
                                alt: "",
                                quality: 60
                            })
                        })
                    }),
                    isMobileByWidth && hasTypicalMobileImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        lineHeight: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: typicalMobileImage.url,
                                style: {
                                    objectFit: "cover"
                                },
                                fill: true,
                                priority: true,
                                alt: "",
                                quality: 60
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                ref: gridRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            pt: 8,
                                            pb: 4,
                                            height: avatarSize + avatarBorderSize * 2 + 48,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            bgcolor: "background.default",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    display: "flex",
                                                    pr: isMobileByWidth ? 0 : 5,
                                                    children: [
                                                        hasLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            mr: 5,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarRelativeWrapper, {
                                                                $withTypicalImage: hasTypicalImage,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarWrapper, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                                                        src: logoImage.url
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NameWrapper, {
                                                            $withTypicalImage: hasTypicalImage,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                    variant: "headlineMedium",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                        color: "text.minus2",
                                                                        children: vender === null || vender === void 0 ? void 0 : vender.shortname
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        gap: "20px",
                                                        height: "100%",
                                                        children: [
                                                            !!contactPhone && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                id: "contact",
                                                                className: "action",
                                                                variant: "outlined",
                                                                color: "primary",
                                                                sx: {
                                                                    fontSize: "18px",
                                                                    width: "180px",
                                                                    height: "54px"
                                                                },
                                                                onClick: onContactNumberBtnClick,
                                                                children: "聯絡電話"
                                                            }),
                                                            isGoToReservationBtnShown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                width: "180px",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_Controls, {
                                                                    vender: vender,
                                                                    onExternalLinkClick: handleExternalLinkClick
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 4,
                                        children: [
                                            joinYears >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                p: 2,
                                                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            variant: "labelLarge",
                                                            color: "text.minus1",
                                                            sx: {
                                                                cursor: "pointer"
                                                            },
                                                            onClick: ()=>setJoinYearsModalOpen(true),
                                                            children: [
                                                                joinYears,
                                                                "年"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* InfoModal */.nv, {
                                                            open: isJoinYearsModalOpen,
                                                            onClose: ()=>setJoinYearsModalOpen(false),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                    variant: "paraBodyMedium",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                        p: 5,
                                                                        textAlign: "center",
                                                                        children: [
                                                                            vender === null || vender === void 0 ? void 0 : vender.shortname,
                                                                            " 已加入信義居家 ",
                                                                            joinYears,
                                                                            " 年"
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    display: "flex",
                                                                    justifyContent: "flex-end",
                                                                    px: 5,
                                                                    pb: 5,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBasic/* default */.Z, {
                                                                        variant: "outlined",
                                                                        onClick: ()=>setJoinYearsModalOpen(false),
                                                                        size: "medium",
                                                                        color: "neutral",
                                                                        sx: {
                                                                            borderColor: "text.minus1"
                                                                        },
                                                                        children: "關閉"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinYearsTooltip, {
                                                    title: "".concat(vender === null || vender === void 0 ? void 0 : vender.shortname, " 已加入信義居家 ").concat(joinYears, " 年"),
                                                    followCursor: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "labelLarge",
                                                        color: "text.minus1",
                                                        children: [
                                                            joinYears,
                                                            "年"
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                display: "flex",
                                                alignItems: "center",
                                                p: 2,
                                                gap: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye/* EyeSVG */.P, {
                                                            $color: "text.minus1"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "labelLarge",
                                                            color: "text.minus1",
                                                            children: pageViews.toLocaleString()
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        children: hasVisibleVenderFeatureTag && (isMobile ? // mobile 版
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderFeatureTagWrapperForMobile, {
                                            children: sortedVisibleVenderFeatureTag.slice(0, 30).map((featureTag, index)=>featureTag.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    display: "inline-block",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Tag, {
                                                        size: "sm",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                                                            children: featureTag.name
                                                        })
                                                    })
                                                }, index))
                                        }) : // desktop 版
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 2,
                                            children: sortedVisibleVenderFeatureTag.slice(0, 30).map((featureTag, index)=>featureTag.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    display: "inline-block",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Tag, {
                                                        size: "sm",
                                                        children: featureTag.name
                                                    })
                                                }, index))
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        my: 5,
                                        display: "flex",
                                        columnGap: {
                                            lg: 6
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                style: {
                                                    flexGrow: 3,
                                                    flexBasis: "0%",
                                                    minWidth: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_VenderServiceInfoSimplified, {
                                                                vender: vender
                                                            })
                                                        }),
                                                        !!resolvedContactData.links.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Vender_VenderRelatedLinks, {
                                                            links: resolvedContactData.links,
                                                            vender: vender,
                                                            clickLocation: "下方連結",
                                                            onExternalLinkClick: handleExternalLinkClick,
                                                            columnGap: 4,
                                                            rowGap: 2
                                                        })
                                                    ]
                                                })
                                            }),
                                            !!favorableDiscountText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                                sx: {
                                                    flexGrow: 2,
                                                    flexBasis: "0%",
                                                    minWidth: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    width: "100%",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_DiscountInfoBlock, {
                                                        vender: venderWithWelcomePreview,
                                                        expanded: isDiscountExpanded,
                                                        onExpandedChange: setDiscountExpanded,
                                                        $borderColor: "primary.minus2"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInDesktopBox */.aI, {
                                        children: !!favorableDiscountText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            mb: 5,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_DiscountInfoBlock, {
                                                vender: venderWithWelcomePreview,
                                                expanded: isDiscountExpanded,
                                                onExpandedChange: setDiscountExpanded,
                                                $borderColor: "primary.minus2"
                                            })
                                        })
                                    }),
                                    !!announcementText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        mb: 8,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBlock/* default */.Z, {
                                            px: 5,
                                            py: 6,
                                            display: "flex",
                                            alignItems: "center",
                                            $bgColor: "grey.third",
                                            $borderColor: "grey.secondary",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertCircle/* AlertCircleSVG */.u, {
                                                        $color: "text.minus1",
                                                        style: {
                                                            verticalAlign: "middle",
                                                            display: "block"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    style: {
                                                        verticalAlign: "middle",
                                                        marginLeft: "8px",
                                                        lineHeight: "24px",
                                                        fontSize: "14px"
                                                    },
                                                    children: announcementText
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stickable/* default */.Z, {
                                $isSticky: isSticky,
                                $isHideScrollbar: true,
                                $hasHeader: true,
                                $bgColor: theme.palette.background.default,
                                $zIndex: 10,
                                $mobileFullWidth: true,
                                style: {
                                    marginBottom: "24px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomTabs, {
                                    ref: customTabsRef,
                                    value: currentPageType,
                                    variant: "scrollable",
                                    indicatorColor: "primary",
                                    textColor: "primary",
                                    "aria-label": "廠商頁面選單",
                                    TabIndicatorProps: {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "MuiTabs-indicatorSpan"
                                        }),
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center",
                                            background: "transparent"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTab, {
                                            value: "home",
                                            label: "首頁",
                                            component: A/* default */.Z,
                                            href: "/vender/".concat(vender === null || vender === void 0 ? void 0 : vender.urlId),
                                            scroll: false,
                                            onClick: (event)=>onVenderTabClick(event, "首頁", "home")
                                        }),
                                        !!articleCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTab, {
                                            value: "article",
                                            label: "文章",
                                            component: "a",
                                            href: "/article/vender-id/".concat(vender === null || vender === void 0 ? void 0 : vender._id),
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            onClick: ()=>sendTabGtmEvent("文章")
                                        }),
                                        !!albumCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTab, {
                                            value: "album",
                                            label: "相簿",
                                            component: "a",
                                            href: "/album?venderId=".concat(vender === null || vender === void 0 ? void 0 : vender._id),
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            onClick: ()=>sendTabGtmEvent("相簿")
                                        }),
                                        hasAbout && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTab, {
                                            value: "about",
                                            label: "公司介紹",
                                            component: A/* default */.Z,
                                            href: "/vender/".concat(vender === null || vender === void 0 ? void 0 : vender.urlId, "/about"),
                                            scroll: false,
                                            onClick: (event)=>onVenderTabClick(event, "公司介紹", "about")
                                        }),
                                        hasContact && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTab, {
                                            value: "contact",
                                            label: "聯繫資訊",
                                            component: A/* default */.Z,
                                            href: "/vender/".concat(vender === null || vender === void 0 ? void 0 : vender.urlId, "/contact"),
                                            scroll: false,
                                            onClick: (event)=>onVenderTabClick(event, "聯繫資訊", "contact")
                                        })
                                    ]
                                })
                            }),
                            isContactPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Vender_VenderContact, {
                                data: resolvedContactData,
                                vender: vender,
                                loggedIn: loggedIn,
                                onPhoneDetailClick: openContactNumberModal,
                                onLoginRequired: ()=>setLoginModalOpen(true),
                                onExternalLinkClick: handleExternalLinkClick
                            }) : isAboutPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicVenderAbout, {
                                data: resolvedAboutData,
                                venderName: vender === null || vender === void 0 ? void 0 : vender.name,
                                venderId: vender === null || vender === void 0 ? void 0 : vender._id,
                                onContentReady: restorePendingTabScrollPosition
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        children: [
                                            hasNewLayout ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    !!(venderBanners === null || venderBanners === void 0 ? void 0 : venderBanners.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_VenderBannerCarousel, {
                                                        banners: venderBanners,
                                                        isMobile: isMobile,
                                                        venderName: vender === null || vender === void 0 ? void 0 : vender.name,
                                                        venderId: vender === null || vender === void 0 ? void 0 : vender._id
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_VenderServiceIntro, {
                                                        serviceIntro: venderServiceIntro
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_VenderServiceItems, {
                                                        serviceItems: venderServiceItems,
                                                        venderName: vender === null || vender === void 0 ? void 0 : vender.name,
                                                        venderId: vender === null || vender === void 0 ? void 0 : vender._id
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_VenderServiceFlows, {
                                                        serviceFlows: venderServiceFlows
                                                    })
                                                ]
                                            }) : /* 舊版版面：廠商介紹模組 */ /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_Company, {
                                                vender: vender,
                                                containerId: containerId
                                            }),
                                            !!albumCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                mb: 18,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ResponsiveDiv/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            pb: 6,
                                                            variant: "h5",
                                                            children: "相簿圖輯"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAlbums, {
                                                        venderId: vender === null || vender === void 0 ? void 0 : vender._id,
                                                        containerId: containerId,
                                                        isMobile: isMobile,
                                                        count: albumCount,
                                                        nativeHeaderControlHandler: invokeNativeHeaderControls
                                                    }),
                                                    isAlbumMoreThanDisplayNum && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                        id: "show_all_albums",
                                                        className: "action",
                                                        variant: "outlined",
                                                        size: "small",
                                                        color: "primary",
                                                        sx: {
                                                            marginTop: "24px",
                                                            color: "#383838",
                                                            borderColor: "#383838",
                                                            fontWeight: 400
                                                        },
                                                        onClick: onShowAllAlbumsBtnClick,
                                                        children: [
                                                            "顯示全部 ",
                                                            albumCount,
                                                            " 本相簿"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !!articleCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                mb: 18,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ResponsiveDiv/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            pb: 6,
                                                            variant: "h5",
                                                            children: "文章撰寫"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicArticles, {
                                                        venderId: vender === null || vender === void 0 ? void 0 : vender._id,
                                                        containerId: containerId,
                                                        venderName: vender === null || vender === void 0 ? void 0 : vender.name
                                                    }),
                                                    isArticleMoreThanDisplayNum && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                        id: "show_all_articles",
                                                        className: "action",
                                                        variant: "outlined",
                                                        size: "small",
                                                        color: "primary",
                                                        sx: {
                                                            marginTop: "24px",
                                                            color: "#383838",
                                                            borderColor: "#383838",
                                                            fontWeight: 400
                                                        },
                                                        onClick: onShowAllArticlesBtnClick,
                                                        children: [
                                                            "顯示全部 ",
                                                            articleCount,
                                                            " 篇文章"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    hasNewLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_VenderWhyChooseUs, {
                                        reasons: venderWhyChooseUs === null || venderWhyChooseUs === void 0 ? void 0 : venderWhyChooseUs.reasons,
                                        image: venderWhyChooseUs === null || venderWhyChooseUs === void 0 ? void 0 : venderWhyChooseUs.image
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderContent_VenderCertification, {
                                        sinyiLivingCertification: venderSinyiLivingCertification
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "paraBodySmall",
                                    color: "text.secondary",
                                    children: [
                                        "*",
                                        Vender_constants/* VENDER_AD_WARNING_TEXT */.r
                                    ]
                                })
                            })
                        ]
                    }),
                    (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
                    })
                ]
            })
        ]
    });
};
VenderContent.defaultProps = {
    isMobile: true,
    pageType: "home"
};
/* harmony default export */ var Vender_VenderContent = (VenderContent);


/***/ }),

/***/ 7676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ VENDER_AD_WARNING_TEXT; }
/* harmony export */ });
const VENDER_AD_WARNING_TEXT = "本網頁/APP廣告頁僅提供廠商預約相關服務刊登廣告，相關廣告文宣及其商品或服務均由廠商自行提供，與信義房屋/信義居家無涉，信義房屋/信義居家無法擔保廠商廣告內容的正確性、可信度或即時性，亦不為其商品、服務品質負責，所生任何爭議皆請自行與廠商協調解決。";


/***/ }),

/***/ 3491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ setVenderViewedOrClicked; }
/* harmony export */ });
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72673);

const setVenderViewedOrClicked = (venderId, params)=>{
    return (0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .safeAwait */ .Ev)((0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .lsPut */ .OL)("/venders/".concat(venderId, "/clicksOrViews"), params));
};


/***/ }),

/***/ 61908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useAlbumCount; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useAlbumCount = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/albums/count?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)({
                ...propsObject,
                limit: 30
            }));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ }),

/***/ 43921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useArticleCount; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72673);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86700);



const useArticleCount = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return [
                "/articles/count?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(propsObject)),
                utils_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getToken */ .ZP.getToken()
            ];
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_2__/* .useCustomSWR */ .LW)(genUrl, utils_request__WEBPACK_IMPORTED_MODULE_1__/* .lsGetWithToken */ .n8, swrOptions);
};


/***/ }),

/***/ 56724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useVenderSupportItems; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72673);



const useVenderSupportItems = (dataSource, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const props = typeof dataSource === "function" ? dataSource() : dataSource;
            if (props === null) {
                return null;
            }
            return [
                "/venders/supportServices?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(props)),
                utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .ZP.getToken()
            ];
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, utils_request__WEBPACK_IMPORTED_MODULE_2__/* .lsGet */ .UY, swrOptions);
};


/***/ }),

/***/ 75082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getVenderJoinedYears; }
/* harmony export */ });
const getVenderJoinedYears = (dateStr)=>{
    if (!dateStr) return 0;
    const joinedDate = new Date(dateStr);
    if (isNaN(joinedDate.getTime())) return 0;
    const now = new Date();
    let years = now.getFullYear() - joinedDate.getFullYear();
    const monthDiff = now.getMonth() - joinedDate.getMonth();
    if (monthDiff < 0 || monthDiff === 0 && now.getDate() < joinedDate.getDate()) {
        years--;
    }
    return Math.max(0, years);
};


/***/ }),

/***/ 19575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ getVenderWelcomeInfo; }
/* harmony export */ });
const getText = (value)=>{
    if (typeof value === "string") return value;
    return (value === null || value === void 0 ? void 0 : value.text) || "";
};
const getVenderWelcomeInfo = (vender)=>{
    var _welcomeInfoSetting_logo;
    const welcomeInfoSetting = (vender === null || vender === void 0 ? void 0 : vender.welcomeInfoSetting) || {};
    const typicalImages = (welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.typicalImages) || {};
    return {
        logoImage: (welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : (_welcomeInfoSetting_logo = welcomeInfoSetting.logo) === null || _welcomeInfoSetting_logo === void 0 ? void 0 : _welcomeInfoSetting_logo.image) || null,
        typicalImage: (typicalImages === null || typicalImages === void 0 ? void 0 : typicalImages.typicalImage) || null,
        typicalMobileImage: (typicalImages === null || typicalImages === void 0 ? void 0 : typicalImages.typicalMobileImage) || null,
        announcementText: getText(welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.announcement),
        favorableDiscountText: getText(welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.favorableDiscount),
        brieflyDescribeText: getText(welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.brieflyDescribe)
    };
};


/***/ })

}]);